<template>
  <loading-overlay :active="isLoading" :is-full-page="false" :width="128" :height="128" :loader="loader"
    :color="loadercolor" :background-color="loaderbackcolor" />

  <SrcBackgroundScroll @scrolled="isShrunk = $event">

    <div class="fixed top-0 w-full max-w-5xl z-20">
      <div v-if="!isLoading"
        class="w-full flex mb-0 bg-skin-b-list-back divide-x md:border-x border-b border-skin-b-list-bord shadow lg:rounded-b-lg">

        <div class="inline-flex grow pl-4">


          <div class="relative mt-4">


            <ul v-if="!this.$store.state.Mesh&&client_info.name" class="w-[17.25rem] h-11
              appearance-none truncate
              rounded-t-lg
              border-b-2 border-skin-b-list-bord
              font-bold text-right text-skin-b-list-base text-2xl">
              <li class="px-3 py-1 truncate" v-html="client_info.name">
              </li>
            </ul>
            <ul v-if="this.$store.state.Mesh&&client_info.name" @click="wbselectshow=!wbselectshow;polling=false;"
              class="w-[17.25rem] h-11
              appearance-none truncate
              cursor-pointer rounded-t-lg
              border-b-2 border-skin-focus
              font-bold text-right text-skin-b-list-base text-2xl
              hover:bg-skin-active128/10
              disabled:opacity-50 disabled:hover:bg-skin-b-list-back 
              focus:bg-skin-active128/5 focus:outline-none focus:ring-0 
              transition duration-300 ease-in-out">
              <li class="px-3 py-1 truncate">
                <span v-if="client_info.serial==this.$store.state.WbLogSerial" class="inline-flex mr-1 mt-1">
                  <svg class="pt-1" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 96 960 960" width="24">
                    <path
                      d="M480 912v-72h264V312H480v-72h264q29.7 0 50.85 21.15Q816 282.3 816 312v528q0 29.7-21.15 50.85Q773.7 912 744 912H480Zm-72-168-51-51 81-81H144v-72h294l-81-81 51-51 168 168-168 168Z" />
                  </svg>
                </span>{{ this.decodeHtml(client_info.name) }}
              </li>
            </ul>
            <div v-if="wbselectshow"
              class="absolute z-10 top-0 left-0 w-[17.25rem] bg-skin-b-list-back rounded-lg border-2 border-skin-focus">
              <div v-for="(wbselect, index) in clients_list" :key="index">
                <div
                  @click="polling=true;this.$store.commit('setWbName', wbselect.name);this.$store.commit('setWbId', wbselect.id);wbselectshow=false;this.updatepage();"
                  :class="[wbselect.id==this.$store.state.WbId ? 'bg-skin-active128/5' : 'bg-skin-b-list-back', index==0 ? 'rounded-t-lg' : '', index==this.clients_list.length-1 ? 'rounded-b-lg' : '']"
                  class="px-3 py-1 cursor-pointer font-bold hover:bg-skin-active128/10 text-skin-b-list-base text-xl truncate">
                  <span v-if="wbselect.hostname==this.$store.state.WbLogHost" class="inline-flex mr-1">
                    <svg class="pt-1" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 96 960 960" width="20">
                      <path
                        d="M480 912v-72h264V312H480v-72h264q29.7 0 50.85 21.15Q816 282.3 816 312v528q0 29.7-21.15 50.85Q773.7 912 744 912H480Zm-72-168-51-51 81-81H144v-72h294l-81-81 51-51 168 168-168 168Z" />
                    </svg>
                  </span>{{ this.decodeHtml(wbselect.name) }}
                </div>

              </div>
            </div>

            <svg class="-mt-2" width="200" height="8" viewbox="0 0 200 8" xmlns="http://www.w3.org/2000/svg">
              <!--GehÃ¤use oberer Teil-->
              <path v-if="client_info.name" fill=rgb(var(--color-text-b-list-base)) :d="svgdata[0].wb_housingtop">
              </path>
            </svg>
            <svg class="" width="200" height="150" viewbox="0 0 200 150" xmlns="http://www.w3.org/2000/svg">

              <!--Wallbox Inset-->
              <g v-if="client_info.wallboxStatus=='unknown'||client_info.wallboxStatus=='booting'">
                <rect fill="currentColor" fill-opacity=".125" height="40.865341" rx="3.338637" ry="3.36538"
                  width="29.570795" x="25.214592" y="15.153822">
                </rect>
              </g>
              <g v-if="client_info.wallboxStatus=='idle'">
                <rect fill=rgb(34,197,94) fill-opacity=".5" height="40.865341" rx="3.338637" ry="3.36538"
                  width="29.570795" x="25.214592" y="15.153822">
                </rect>
              </g>
              <g v-if="client_info.wallboxStatus=='wait_unlock'||client_info.wallboxStatus=='connected'">
                <rect fill=rgb(234,179,8) fill-opacity=".5" height="40.865341" rx="3.338637" ry="3.36538"
                  width="29.570795" x="25.214592" y="15.153822">
                </rect>
              </g>
              <g v-if="client_info.wallboxStatus=='auth_ok'">
                <rect fill=rgb(255,255,255) fill-opacity=".5" height="40.865341" rx="3.338637" ry="3.36538"
                  width="29.570795" x="25.214592" y="15.153822">
                </rect>
              </g>
              <g v-if="client_info.wallboxStatus=='loading'||client_info.wallboxStatus=='loading_paused'">
                <rect fill=rgb(59,130,246) fill-opacity=".5" height="40.865341" rx="3.338637" ry="3.36538"
                  width="29.570795" x="25.214592" y="15.153822">
                </rect>
              </g>
              <g v-if="client_info.wallboxStatus=='loading_planned'">
                <rect fill=rgb(139,92,246) fill-opacity=".5" height="40.865341" rx="3.338637" ry="3.36538"
                  width="29.570795" x="25.214592" y="15.153822">
                </rect>
              </g>
              <g v-if="client_info.wallboxStatus=='loading_done'"><!--GrÃ¼n rgb(34,197,94) -->
                <rect fill=rgb(59,130,246) fill-opacity=".5" height="40.865341" rx="3.338637" ry="3.36538"
                  width="29.570795" x="25.214592" y="15.153822">
                </rect>
              </g>
              <g v-if="client_info.wallboxStatus=='error'||client_info.wallboxStatus=='no_connection'">
                <rect fill=rgb(239,68,68) fill-opacity=".5" height="40.865341" rx="3.338637" ry="3.36538"
                  width="29.570795" x="25.214592" y="15.153822">
                </rect>
              </g>

              <!--LEDs-->
              <g v-if="client_info.name">
                <path fill=rgb(var(--color-text-b-list-base)) :d="svgdata[2].wb_leds" />
              </g>
              <!--RFID Logo-->
              <g v-if="client_info.wallboxStatus=='wait_unlock'">
                <path fill=rgb(var(--color-text-b-list-base)) :d="svgdata[3].wb_rfidlogo" />
              </g>
              <!--GehÃ¤use unterer Teil-->
              <path v-if="client_info.name" fill=rgb(var(--color-text-b-list-base)) :d="svgdata[1].wb_housing" />
              <!--Ladekabel am Auto angesteckt-->
              <g
                v-if="client_info.wallboxStatus=='loading'||client_info.wallboxStatus=='loading_paused'||client_info.wallboxStatus=='wait_unlock'||client_info.wallboxStatus=='connected'||client_info.wallboxStatus=='loading_done'||client_info.wallboxStatus=='auth_ok'||client_info.wallboxStatus=='loading_planned'||client_info.wallboxStatus=='error'">
                <path fill=rgb(var(--color-text-b-list-base)) :d="svgdata[4].cable_carconnect" />
              </g>
              <!--Ladekabel an Box angesteckt-->
              <g
                v-if="client_info.wallboxStatus=='idle'||client_info.wallboxStatus==''||client_info.wallboxStatus=='booting'">
                <path fill=rgb(var(--color-text-b-list-base)) :d="svgdata[5].cable_wbconnect" />
              </g>
              <!--Auto transparent-->
              <g
                v-if="client_info.wallboxStatus=='idle'||client_info.wallboxStatus==''||client_info.wallboxStatus=='booting'">
                <path fill=rgb(var(--color-text-b-list-base)) fill-opacity=".125" :d="svgdata[6].car_full" />
              </g>
              <!--Auto ohne Batterie-->
              <g
                v-if="client_info.wallboxStatus=='wait_unlock'||client_info.wallboxStatus=='connected'||client_info.wallboxStatus=='auth_ok'||client_info.wallboxStatus=='loading_planned'||client_info.wallboxStatus=='error'">
                <path fill=rgb(var(--color-text-b-list-base)) :d="svgdata[7].car_line" />
              </g>
              <!--Auto mit Batterie-->
              <g
                v-if="client_info.wallboxStatus=='loading'||client_info.wallboxStatus=='loading_paused'||client_info.wallboxStatus=='loading_done'">
                <path fill=rgb(var(--color-text-b-list-base)) :d="svgdata[8].car_linebattery" />
              </g>
              <!--Ladebalken animiert-->
              <g v-if="client_info.wallboxStatus=='loading'">
                <rect transform="rotate(180,97,86.08316)" fill=rgb(59,130,246) width="17" height="37" x="80"
                  y="49.08316">
                  <animate attributeName="height" from="0" to="37" dur="10s" begin="0s" repeatCount="indefinite" />
                </rect>
              </g>
              <!--Ladebalken Pausiert-->
              <g v-if="client_info.wallboxStatus=='loading_paused'">
                <rect transform="rotate(180,97,86.08316)" fill=rgb(59,130,246) width="17" height="37" x="80"
                  y="49.08316">
                  <animate attributeName="opacity" values="0;1;0" dur="2s" repeatCount="indefinite" />
                </rect>
              </g>
              <!--Ladebalken Geladen-->
              <g v-if="client_info.wallboxStatus=='loading_done'">
                <rect transform="rotate(180,97,86.08316)" fill=rgb(59,130,246) width="17" height="37" x="80"
                  y="49.08316">
                </rect>
              </g>
            </svg>
            <div
              class="absolute top-[3.075rem] left-16 w-[12.25rem] ml-auto text-right font-semibold text-lg text-skin-b-list-mute">
              <h4 v-if="client_info.wallboxStatus==''">
                <span v-html="$t('statusshort.unknown')"></span>
              </h4>
              <h4 v-if="client_info.wallboxStatus=='idle'">
                <span v-html="$t('statusshort.idle')"></span>
              </h4>
              <h4 v-if="client_info.wallboxStatus=='booting'">
                <span v-html="$t('statusshort.booting')"></span>
              </h4>
              <h4 v-if="client_info.wallboxStatus=='auth_ok'" class="text-skin-b-list-base">
                <span v-html="$t('statusshort.auth_ok')"></span>
              </h4>
              <h4 v-if="client_info.wallboxStatus=='pairing'">
                <span v-html="$t('statusshort.pairing')"></span>
              </h4>
              <h4 v-if="client_info.wallboxStatus=='connected'">
                <span v-html="$t('statusshort.connected')"></span>
              </h4>
              <h4
                v-if="(client_info.wallboxStatus=='loading'||client_info.wallboxStatus=='loading_paused')&&loadedenergy>0"
                class="font-bold text-lg text-skin-b-list-base">
                <span>{{ loadtime }}<br>{{ $t('main.loadedenergy', { Energy: $n( loadedenergy, 'decimal' ) } ) }}</span>
              </h4>
              <h4
                v-if="(client_info.wallboxStatus=='loading'||client_info.wallboxStatus=='loading_paused')&&loadedenergy==0"
                class="font-bold text-lg text-skin-b-list-base">
                <span>{{ loadtime }}</span>
              </h4>
              <h4 v-if="client_info.wallboxStatus=='loading_planned'" class="text-skin-b-list-base">
                <span v-html="$t('statusshort.loading_planned')"></span>
              </h4>
              <h4 v-if="client_info.wallboxStatus=='loading_done'" class="text-skin-b-list-base">
                <span v-html="$t('status.loading_done')"></span><span><br>{{ $t('main.loadedenergy', { Energy: $n(
                  loadedenergy, 'decimal' ) } ) }}</span>
              </h4>
              <h4 v-if="client_info.wallboxStatus=='error'" class="text-skin-b-list-base">
                <span v-html="$t('statusshort.error')"></span><span><br>{{ errorcodetxt }}</span>
              </h4>
            </div>
            <!--Freigabe Button "Ladung freigeben fÃ¼r Solar und Fast"  wird es nicht geben-->
            <!--
            <div v-if="client_info.wallboxStatus=='wait_unlock'&&solarcharge" class="w-full mb-4 inline-flex items-center">
                <button @click.prevent="submitForm" @click="AuthCharging('Solar');" type="button" class="inline-flex items-center px-2 py-1 text-sm font-semibold 
                    text-skin-b-list-base bg-skin-b-list-back rounded-l-md border-l-2 border-y-2 border-skin-b-list-bord
                    text-yellow-800 bg-yellow-100
                    hover:text-yellow-900 hover:bg-yellow-200
                    disabled:text-yellow-800 disabled:bg-yellow-100
                    focus:z-10 focus:ring-0 focus:ring-transparent focus:text-skin-b-base">
                  <svg class="w-5 h-5 fill-current mr-2" fill="currentColor" viewBox="0 -960 960 960"
                    xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M450-770v-150h60v150h-60Zm256 106-42-42 106-107 42 43-106 106Zm64 214v-60h150v60H770ZM450-40v-150h60v150h-60ZM253-665 148-770l42-42 106 106-43 41Zm518 517L664-254l41-41 108 104-42 43ZM40-450v-60h150v60H40Zm151 302-43-42 105-105 22 20 22 21-106 106Zm289-92q-100 0-170-70t-70-170q0-100 70-170t170-70q100 0 170 70t70 170q0 100-70 170t-170 70Zm0-60q75 0 127.5-52.5T660-480q0-75-52.5-127.5T480-660q-75 0-127.5 52.5T300-480q0 75 52.5 127.5T480-300Zm0-180Z" />
                  </svg>
                  {{ $t('main.authchargingsolar') }}
                </button>
                <button @click.prevent="submitForm" @click="AuthCharging('Fast');" type="button" class="inline-flex items-center px-2 py-1 text-sm font-semibold 
                    text-skin-b-list-base bg-skin-b-list-back rounded-r-md border-2 border-skin-b-list-bord
                    text-yellow-800 bg-yellow-100
                    hover:text-yellow-900 hover:bg-yellow-200
                    disabled:text-yellow-800 disabled:bg-yellow-100
                    focus:z-10 focus:ring-0 focus:ring-transparent focus:text-skin-b-base">
                  <svg class="w-5 h-5 fill-current mr-2" fill="currentColor" viewBox="0 -960 960 960"
                    xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M715-360v-60h95q13 0 21.5 8.5T840-390q0 12-8.5 21t-21.5 9h-95Zm0 160v-60h95q13 0 21.5 8.5T840-230q0 12-8.5 21t-21.5 9h-95Zm-155 40q-29 0-49.5-23.5T490-240h-95v-140h95q0-33 20.5-56.5T560-460h125v300H560ZM275-280q-67 0-111-43.5T120-435q0-68 44-111.5T275-590h65q33 0 54-21t21-54q0-33-21-54t-54-21H190q-12 0-21-9t-9-21q0-13 9-21.5t21-8.5h150q58 0 96.5 38.5T475-665q0 58-38.5 96.5T340-530h-65q-42 0-68.5 26T180-435q0 43 26.5 69t68.5 26h90v60h-90Z" />
                  </svg>
                  {{ $t('main.authchargingfast') }}
                </button>
          </div>-->
          <!--Freigabe Button "Ladung freigeben" wird auch bei idle angezeigt v-if="client_info.wallboxStatus=='wait_unlock'&&!solarcharge"-->
          <div v-if="client_info.wallboxStatus=='idle'||client_info.wallboxStatus=='wait_unlock'" class="w-full mb-4 inline-flex items-center">
                <button @click.prevent="submitForm" @click="AuthCharging('Fast');" type="button" class="w-full text-center px-2 py-1 text-sm font-semibold 
                    text-skin-b-list-base bg-skin-b-list-back rounded-md border-2 border-skin-b-list-bord
                    text-yellow-800 bg-yellow-100
                    hover:text-yellow-900 hover:bg-yellow-200
                    disabled:text-yellow-800 disabled:bg-yellow-100
                    focus:z-10 focus:ring-0 focus:ring-transparent focus:text-skin-b-base">
                  {{ $t('main.authcharging') }}
                </button>
          </div>
            <!--Stoppen ohne PV Button-->
            <div
              v-if="!solarcharge&&(client_info.wallboxStatus=='loading_planned'||client_info.wallboxStatus=='loading'||client_info.wallboxStatus=='loading_paused')"
              class="w-full mb-4 inline-flex items-center">
              <button @click.prevent="submitForm" @click="stopchargingshow=true" type="button" class="inline-flex items-center px-2 py-1 text-sm font-semibold 
                  text-skin-b-list-base bg-skin-b-list-back rounded-md border-2 border-skin-b-list-bord
                  hover:text-amber-800 hover:bg-amber-100
                  disabled:text-amber-800 disabled:bg-amber-100
                  focus:z-10 focus:ring-0 focus:ring-transparent focus:text-skin-b-base">
                <svg class="w-5 h-5 fill-current mr-2" fill="currentColor" viewBox="0 -960 960 960"
                  xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M320-320h320v-320H320v320ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
                </svg>
                {{ client_info.wallboxStatus==='loading_planned' ? $t('main.deleteplannedcharging') : $t('main.stopcharging') }}
              </button>
            </div>
            <!--Stoppen mit PV Button-->
            <div
              v-if="solarcharge&&(client_info.wallboxStatus=='loading_planned')"
              class="w-full mb-4 inline-flex items-center">
              <button @click.prevent="submitForm" @click="stopchargingshow=true" type="button" class="inline-flex items-center px-2 py-1 text-sm font-semibold 
                  text-skin-b-list-base bg-skin-b-list-back rounded-md border-2 border-skin-b-list-bord
                  hover:text-amber-800 hover:bg-amber-100
                  disabled:text-amber-800 disabled:bg-amber-100
                  focus:z-10 focus:ring-0 focus:ring-transparent focus:text-skin-b-base">
                <svg class="w-5 h-5 fill-current mr-2" fill="currentColor" viewBox="0 -960 960 960"
                  xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M320-320h320v-320H320v320ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
                </svg>
                {{ $t('main.deleteplannedcharging') }}
              </button>
            </div>
            <!--PV-Schnell + Stoppen Button-->
            <div v-if="solarcharge&&(client_info.wallboxStatus=='loading'||client_info.wallboxStatus=='loading_paused')"
              class="w-full mb-4 inline-flex items-center">
              <button @click.prevent="submitForm" @click="SolarchargeOn(chargerfid)" type="button"
                :disabled="solarchargemode=='Solar'" class="inline-flex items-center px-2 py-1 text-sm font-semibold 
                  text-skin-b-list-base bg-skin-b-list-back rounded-l-md border-l-2 border-y-2 border-skin-b-list-bord
                  hover:text-amber-800 hover:bg-amber-100
                  disabled:text-amber-800 disabled:bg-amber-100
                  focus:z-10 focus:ring-0 focus:ring-transparent focus:text-skin-b-base">
                <svg class="w-5 h-5 fill-current mr-2" fill="currentColor" viewBox="0 -960 960 960"
                  xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M450-770v-150h60v150h-60Zm256 106-42-42 106-107 42 43-106 106Zm64 214v-60h150v60H770ZM450-40v-150h60v150h-60ZM253-665 148-770l42-42 106 106-43 41Zm518 517L664-254l41-41 108 104-42 43ZM40-450v-60h150v60H40Zm151 302-43-42 105-105 22 20 22 21-106 106Zm289-92q-100 0-170-70t-70-170q0-100 70-170t170-70q100 0 170 70t70 170q0 100-70 170t-170 70Zm0-60q75 0 127.5-52.5T660-480q0-75-52.5-127.5T480-660q-75 0-127.5 52.5T300-480q0 75 52.5 127.5T480-300Zm0-180Z" />
                </svg>
                {{ $t('main.solaron') }}
              </button>
              <button @click.prevent="submitForm" @click="SolarchargeOff(chargerfid)" type="button"
                :disabled="solarchargemode=='Fast'" class="inline-flex grow items-center px-2 py-1 text-sm font-semibold 
                  text-skin-b-list-base bg-skin-b-list-back border-l-2 border-y-2 border-skin-b-list-bord
                  hover:text-amber-800 hover:bg-amber-100
                  disabled:text-amber-800 disabled:bg-amber-100
                  focus:z-10 focus:ring-0 focus:ring-transparent focus:text-skin-b-base">
                <svg class="w-5 h-5 fill-current mr-2" fill="currentColor" viewBox="0 -960 960 960"
                  xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M715-360v-60h95q13 0 21.5 8.5T840-390q0 12-8.5 21t-21.5 9h-95Zm0 160v-60h95q13 0 21.5 8.5T840-230q0 12-8.5 21t-21.5 9h-95Zm-155 40q-29 0-49.5-23.5T490-240h-95v-140h95q0-33 20.5-56.5T560-460h125v300H560ZM275-280q-67 0-111-43.5T120-435q0-68 44-111.5T275-590h65q33 0 54-21t21-54q0-33-21-54t-54-21H190q-12 0-21-9t-9-21q0-13 9-21.5t21-8.5h150q58 0 96.5 38.5T475-665q0 58-38.5 96.5T340-530h-65q-42 0-68.5 26T180-435q0 43 26.5 69t68.5 26h90v60h-90Z" />
                </svg>
                {{ $t('main.solaroff') }}
              </button>
              <button @click.prevent="submitForm" @click="stopchargingshow=true" type="button" class="inline-flex items-center px-2 py-1 text-sm font-semibold 
                  text-skin-b-list-base bg-skin-b-list-back rounded-r-md border-2 border-skin-b-list-bord
                  hover:text-amber-800 hover:bg-amber-100
                  disabled:text-amber-800 disabled:bg-amber-100
                  focus:z-10 focus:ring-0 focus:ring-transparent focus:text-skin-b-base">
                <svg class="w-5 h-5 fill-current mr-2" fill="currentColor" viewBox="0 -960 960 960"
                  xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M320-320h320v-320H320v320ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
                </svg>
                {{ $t('main.stop') }}
              </button>
            </div>

          </div>

          <div class="px-4 py-4 hidden sm:inline-block sm:w-full">
            <ul v-if="client_info.name" class="w-full h-11
              appearance-none 
              border-b-2 border-skin-b-list-bord
              font-bold text-skin-b-list-mute text-lg">
              <li class="px-3 py-2 truncate" v-html="client_info.info">
              </li>
            </ul>
            <!--Statusfeld-->
            <div class="inline-flex float-right -mt-10">

              <span v-if="this.statdlm!=undefined&&this.statdlm!='disabled'&&client_info.name"
                class='mr-2 inline-flex items-center ring-1 ring-inset text-xs font-medium pl-2 pr-2.5 rounded-md py-1'
                :class="[ this.statdlm=='connected' ? 'bg-green-50 text-green-700 ring-green-600/10' : 'bg-red-50 text-red-700 ring-red-600/10' ]">
                <span class='w-2 h-2 mr-1.5 rounded-full flex'
                  :class="[ this.statdlm=='connected' ? 'bg-green-500' : 'bg-red-500' ]"></span>easyBalance </span>

              <span v-if="this.statp14!=undefined&&this.statp14!='disabled'&&client_info.name"
                class='mr-2 inline-flex items-center ring-1 ring-inset text-xs font-medium pl-2 pr-2.5 rounded-md py-1'
                :class="[ this.statp14=='connected' ? 'bg-green-50 text-green-700 ring-green-600/10' : 'bg-red-50 text-red-700 ring-red-600/10' ]">
                <span class='w-2 h-2 mr-1.5 rounded-full flex'
                  :class="[ this.statp14=='connected' ? 'bg-green-500' : 'bg-red-500' ]"></span>§14a </span>

              <span v-if="this.statinternet!=undefined&&client_info.name"
                class='inline-flex items-center ring-1 ring-inset text-xs font-medium pl-2 pr-2.5 rounded-md py-1'
                :class="[ this.statinternet==1 ? 'bg-green-50 text-green-700 ring-green-600/10' : 'bg-red-50 text-red-700 ring-red-600/10' ]">
                <span class='w-2 h-2 mr-1.5 rounded-full flex'
                  :class="[ this.statinternet==1 ? 'bg-green-500' : 'bg-red-500' ]"></span>www </span>

              <span v-if="this.statocpp!=undefined&&this.statocpp!='disabled'&&client_info.name"
                class='inline-flex items-center ring-1 ring-inset text-xs font-medium ml-2 pl-2 pr-2.5 rounded-md py-1'
                :class="[ this.statocpp=='connected' ? 'bg-green-50 text-green-700 ring-green-600/10' : 'bg-red-50 text-red-700 ring-red-600/10' ]">
                <span class='w-2 h-2 mr-1.5 rounded-full flex'
                  :class="[ this.statocpp=='connected' ? 'bg-green-500' : 'bg-red-500' ]"></span>OCPP1 </span>

              <span v-if="this.statocppdlm!=undefined&&this.statocppdlm!='disabled'&&client_info.name"
                class='inline-flex items-center ring-1 ring-inset text-xs font-medium ml-2 pl-2 pr-2.5 rounded-md py-1'
                :class="[ this.statocppdlm=='connected' ? 'bg-green-50 text-green-700 ring-green-600/10' : 'bg-red-50 text-red-700 ring-red-600/10' ]">
                <span class='w-2 h-2 mr-1.5 rounded-full flex'
                  :class="[ this.statocppdlm=='connected' ? 'bg-green-500' : 'bg-red-500' ]"></span>OCPP2 </span>

              <svg v-if="this.statwlan!=undefined&&this.statwlan>-1" class="ml-2 h-8 w-8"
                xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor" aria-hidden="true">
                <path v-if="this.statwlan!=0" :opacity="[this.statwlan<4 ? '.25' : '1']"
                  d="m4.824321-595.17584 101.823379 101.82338c99.03885-99.03885 233.29032-154.65743 373.35237-154.65751 140.06189.0001 274.31364 55.61875 373.3524 154.65751l101.82338-101.82338c-126.00489-126.00488-296.97798-196.81873-475.17573-196.81878-178.19794.0001-349.1709 70.81388-475.175799 196.81878z" />
                <path v-if="this.statwlan!=0" :opacity="[this.statwlan<3 ? '.25' : '1']"
                  d="m157.55939-442.44077 101.82338 101.82338c58.53096-58.53097 137.84209-91.41562 220.61733-91.41566 82.77525-.00003 162.08639 32.88474 220.6173 91.41566l101.82338-101.82338c-85.49703-85.49704-201.52969-133.57685-322.44064-133.57695-120.91112.00007-236.94373 48.07993-322.44075 133.57695z" />
                <path :opacity="[this.statwlan<2 ? '.25' : '1']"
                  d="m310.29445-289.7057 169.70563 169.70563 169.70563-169.70563a240 240 0 0 0 -339.41126 0z" />
                <path v-if="this.statwlan==0"
                  d="m 554.375,-496.66875 -58.33751,-58.33751 105.00001,-105.00001 -105.00001,-105.00001 58.33751,-58.32496 105,104.99997 105.00001,-104.99997 59.5875,58.32496 -105,105.00001 103.75002,105.00001 -58.33752,58.33751 L 659.375,-600.41876 Z" />
              </svg>
              <svg v-if="this.statlte!=undefined&&this.statlte>-1" class="ml-2 h-8 w-8"
                xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor" aria-hidden="true">
                <text class="font-bold" font-size="275" text-anchor="start" x="0" y="-760">LTE</text>
                <g v-if="this.statlte>0">
                  <rect :opacity="[this.statlte<5 ? '.25' : '1']" height="640" rx="20" width="140" x="700" y="-800" />
                  <rect :opacity="[this.statlte<4 ? '.25' : '1']" height="500" rx="20" width="140" x="500" y="-660" />
                  <rect :opacity="[this.statlte<3 ? '.25' : '1']" height="360" rx="20" width="140" x="300" y="-520" />
                  <rect :opacity="[this.statlte<2 ? '.25' : '1']" height="220" rx="20" width="140" x="100" y="-380" />
                </g>
                <g v-if="this.statlte==0">
                  <rect height="110" rx="20" width="140" x="700" y="-270" />
                  <rect height="110" rx="20" width="140" x="500" y="-270" />
                  <rect height="110" rx="20" width="140" x="300" y="-270" />
                  <rect height="110" rx="20" width="140" x="100" y="-270" />
                  <path
                    d="m 554.375,-496.66875 -58.33751,-58.33751 105.00001,-105.00001 -105.00001,-105.00001 58.33751,-58.32496 105,104.99997 105.00001,-104.99997 59.5875,58.32496 -105,105.00001 103.75002,105.00001 -58.33752,58.33751 L 659.375,-600.41876 Z" />
                </g>
              </svg>
            </div>

            <div v-if="charging" class="px-4 py-2 flex items-center group">
              <div class="mr-4">
                <vc-donut class="" background=rgb(var(--color-b-back)) foreground=rgb(var(--color-active-hsl-224))
                  :size="64" unit="px" :thickness="22" :sections="sections" :total="donutmaxchargepower"
                  :start-angle="0" :auto-adjust-text-size="true">
                  <svg v-if="client_info.wallboxStatus!='loading_paused'" :fill=chargecolor class="w-12 h-12"
                    height="512" width="512" viewBox="0 0 135.46666 135.46667" xmlns="http://www.w3.org/2000/svg">
                    <g transform="translate(0 -161.53331)">
                      <circle fill=rgb(var(--color-b-back) cx="-67.73333" cy="229.26663" r="67.73333"
                        transform="scale(-1 1)" />
                      <path
                        d="m62.807018 205.71983c-6.942962.0275-19.327389.59698-28.973941 3.17707-1.09153.29195-1.848273.94097-2.713013 1.72754-.864709.78657-1.766176 1.75445-2.693377 2.79622-1.854409 2.08353-3.81535 4.47241-5.406387 6.07766-.02425.0245-.04768.0499-.07028.076-1.30761 1.50331-1.264471 3.32341-1.381311 5.30666-.11441 1.94208-.13142 4.01618-.31936 5.52266-.71519 2.35664-1.700296 4.20031-1.335836 6.50968.68559 4.73774 1.601459 7.3512 3.168799 8.94727 1.569397 1.59814 3.598763 1.62884 5.065325 1.62884h.850593c1.697905 3.38193 5.164124 5.58484 9.01392 5.58984h.0031c3.851505-.003 7.319875-2.20645 9.018568-5.58984h41.694613c1.697911 3.38196 5.164101 5.58484 9.01392 5.58984h.0041c3.851559-.003 7.319849-2.20643 9.018569-5.58984h.31316c2.13313 0 4.58424.006 6.86263-.27802.014-.002.0279-.004.0419-.006.81905-.12425 2.03783-.28929 3.20807-.73638.58514-.22355 1.17804-.51549 1.70688-1.02681.52872-.51124.96146-1.33825.95446-2.21382.013-3.19325.0492-7.05092-.2713-9.14571-.80547-5.38677-3.45971-8.41327-6.46679-10.73165-.0576-.0444-.11822-.0848-.18138-.12092-1.76217-1.00746-4.20935-1.64022-6.92826-2.281-2.71894-.64078-5.67028-1.23317-8.127677-1.87017-.02806-.007-.05632-.0139-.08475-.0196-1.327526-.26757-2.32119-.56346-2.66237-.90176-.05755-.0572-.119399-.10987-.185002-.15761-11.8339-8.5904-16.882976-10.01579-20.170873-10.89515-3.254164-.8704-5.032375-1.41233-11.966713-1.38493z" />
                    </g>
                  </svg>
                  <svg v-if="client_info.wallboxStatus=='loading_paused'" fill=rgb(var(--color-active-hsl-128))
                    xmlns="http://www.w3.org/2000/svg" height="32" viewBox="0 -960 960 960" width="32">
                    <path d="M555-200v-560h175v560H555Zm-325 0v-560h175v560H230Z" />
                  </svg>
                </vc-donut>
              </div>
              <div class="grow">
                <div v-if="!freecharging" class="mb-2">
                  <span v-if="chargeusername!=''">
                    <strong>{{ chargeusername }}</strong>&nbsp;-&nbsp;
                  </span>
                  <span v-if="chargerfidinfo!=chargerfid">
                    <strong>{{ chargerfidinfo }}</strong>&nbsp;&nbsp;
                  </span>
                  <span v-if="chargeusername==''" class="text-skin-b-list-base">
                    <svg class="inline-block -mt-1" xmlns="http://www.w3.org/2000/svg" height="20" width="20"
                      viewBox="0 96 960 960" fill="currentColor">
                      <path
                        d="M168 864q-29.7 0-50.85-21.5Q96 821 96 792V648q29.7 0 50.85-21.15Q168 605.7 168 576q0-29.7-21.15-50.85Q125.7 504 96 504V360q0-29 21.15-50.5T168 288h624q29.7 0 50.85 21.5Q864 331 864 360v144q-29.7 0-50.85 21.15Q792 546.3 792 576q0 29.7 21.15 50.85Q834.3 648 864 648v144q0 29-21.15 50.5T792 864H168Zm0-72h624v-91q-32-19-52-52t-20-73q0-40 20-73t52-52v-91H168v91q32 19 52 52t20 73q0 40-20 73t-52 52v91Zm311.789-48Q495 744 505.5 733.711q10.5-10.29 10.5-25.5Q516 693 505.711 682.5q-10.29-10.5-25.5-10.5Q465 672 454.5 682.289q-10.5 10.29-10.5 25.5Q444 723 454.289 733.5q10.29 10.5 25.5 10.5Zm0-132Q495 612 505.5 601.711q10.5-10.29 10.5-25.5Q516 561 505.711 550.5q-10.29-10.5-25.5-10.5Q465 540 454.5 550.289q-10.5 10.29-10.5 25.5Q444 591 454.289 601.5q10.29 10.5 25.5 10.5Zm0-132Q495 480 505.5 469.711q10.5-10.29 10.5-25.5Q516 429 505.711 418.5q-10.29-10.5-25.5-10.5Q465 408 454.5 418.289q-10.5 10.29-10.5 25.5Q444 459 454.289 469.5q10.29 10.5 25.5 10.5Zm.211 96Z" />
                    </svg>
                    &nbsp;{{ chargerfid }}
                    <div class="inline-block cursor-pointer" @click="copyToClipBoard(chargerfid)">
                      <svg class="inline-block -mt-1 text-skin-b-mute" xmlns="http://www.w3.org/2000/svg" height="20"
                        viewBox="0 96 960 960" width="20" fill="currentColor">
                        <path
                          d="M216 960q-29.7 0-50.85-21.15Q144 917.7 144 888V336h72v552h456v72H216Zm144-144q-29.7 0-50.85-21.15Q288 773.7 288 744V264q0-29.7 21.15-50.85Q330.3 192 360 192h384q29.7 0 50.85 21.15Q816 234.3 816 264v480q0 29.7-21.15 50.85Q773.7 816 744 816H360Zm0-72h384V264H360v480Zm0 0V264v480Z" />
                      </svg>
                    </div>
                  </span>
                </div>

                <div>
                  <span class="hidden sm:inline-block text-skin-b-list-mute">
                    <svg class="inline-block -mt-1" xmlns="http://www.w3.org/2000/svg" height="20" width="20"
                      fill="currentColor">
                      <path
                        d="m8.5 17 1-5.5H6.625q-.292 0-.385-.156-.094-.156.031-.406L10.5 3h1L11 8.5h2.375q.271 0 .375.146.104.146-.042.416L9.5 17Z" />
                    </svg><!-- energy beim laden-->
                    <span v-if="midavailable" v-html="$t('main.chargepower', { Energy: $n( chargepower, 'decimal' ) } )"></span>
                    <span v-if="maxchargepower>0&&midavailable">&nbsp;{{ $t('main.maxchargepower', { Energy: $n( maxchargepower,
                      'decimal1' ) } ) }}</span>
                    <span v-if="midavailable">&nbsp;&nbsp;&#8231;&nbsp;</span>
                    <svg class="inline-block -mt-1" xmlns="http://www.w3.org/2000/svg" height="20" width="20"
                      fill="currentColor">
                      <path
                        d="m12.792 13.542 1.062-1.063-3.104-3.104V5h-1.5v5ZM10 18q-1.646 0-3.104-.625-1.458-.625-2.552-1.719t-1.719-2.552Q2 11.646 2 10q0-1.667.625-3.125t1.719-2.542Q5.438 3.25 6.896 2.625T10 2q1.667 0 3.125.625t2.542 1.708q1.083 1.084 1.708 2.542Q18 8.333 18 10q0 1.646-.625 3.104-.625 1.458-1.708 2.552-1.084 1.094-2.542 1.719Q11.667 18 10 18Zm0-8Zm0 6.5q2.708 0 4.604-1.906T16.5 10q0-2.708-1.896-4.604T10 3.5q-2.688 0-4.594 1.896Q3.5 7.292 3.5 10q0 2.688 1.906 4.594Q7.312 16.5 10 16.5Z" />
                    </svg>
                    {{ $t('main.chargestarttime', { time: chargestarttime } ) }}
                  </span>
                </div>
              </div>
            </div>

            <div v-if="!charging&&energytotal!=0" class="px-4 pt-2 flex items-center group">
              <div class="mr-4 w-full">
                <h4 class="font-medium text-skin-b-list-mute text-lg truncate">
                  <span v-html="$t('main.energyloadedtotal', { Energy: $n( energytotal, 'decimal' ) } )"></span>
                </h4>
              </div>
            </div>
            <div v-if="client_info.name&&(client_info.serial==this.$store.state.WbLogSerial)"
              class="px-4 pt-1 flex items-center group">
              <div class="mr-4 w-full">
                <h4 class="font-medium text-skin-b-list-mute text-normal truncate">
                  <span>{{ $t('main.serial') }}&nbsp;{{ client_info.serial }}&nbsp;&#8231;&nbsp;{{ $t('main.ip')
                    }}&nbsp;{{ client_info.ip }}</span>
                </h4>
              </div>
            </div>
            <div v-if="client_info.name&&(client_info.serial!=this.$store.state.WbLogSerial)"
              class="px-4 pt-1 flex items-center group">
              <div class="mr-4 w-full">
                <h4 class="font-medium text-skin-b-list-mute text-normal truncate">
                  <span>{{ $t('main.serial') }}&nbsp;{{ client_info.serial }}&nbsp;&#8231;&nbsp;{{ $t('main.ip')
                    }}&nbsp;</span>
                  <span><a class="underline underline-offset-4" :href="'https://' + client_info.ip" target="_blank">{{
                      client_info.ip }}</a></span>
                </h4>
              </div>
            </div>

          </div>
        </div>

        <div class="inline-flex">
          <button type="button" @click="logout()" class="flex flex-col justify-center px-4 py-0 text-sm font-medium rounded-br-lg
                                    text-skin-b-list-base bg-skin-b-list-back 
                                    hover:text-skin-b-base hover:bg-skin-b-list-head  
                                    focus:z-10 focus:ring-0 focus:ring-transparent focus:text-skin-b-base">
            <svg v-if="this.$store.state.Role=='operator'&&client_info.name" class="mb-6" fill=currentColor
              xmlns="http://www.w3.org/2000/svg" height="32" viewBox="0 96 960 960" width="32">
              <path
                d="m667 936-10-66q-17-5-34.5-14.5T593 834l-55 12-25-42 47-44q-2-9-2-25t2-25l-47-44 25-42 55 12q12-12 29.5-21.5T657 600l10-66h54l10 66q17 5 34.5 14.5T795 636l55-12 25 42-47 44q2 9 2 25t-2 25l47 44-25 42-55-12q-12 12-29.5 21.5T731 870l-10 66h-54ZM80 892v-94q0-35 17.5-63t50.5-43q72-32 133.5-46T400 632h23q-21 51-19 134.5T438 892H80Zm614-77q36 0 58-22t22-58q0-36-22-58t-58-22q-36 0-58 22t-22 58q0 36 22 58t58 22ZM400 571q-66 0-108-42t-42-108q0-66 42-108t108-42q66 0 108 42t42 108q0 66-42 108t-108 42Z" />
            </svg>
            <svg v-if="this.$store.state.Role=='admin'&&client_info.name" class="mb-6" fill=currentColor
              xmlns="http://www.w3.org/2000/svg" height="32" viewBox="0 96 960 960" width="32">
              <path
                d="M140 976q-24 0-42-18t-18-42V436q0-24 18-42t42-18h237V236q0-24 18-42t42-18h87q24 0 42 18t18 42v140h236q24 0 42 18t18 42v480q0 24-18 42t-42 18H140Zm92-167h239v-14q0-18-9-32t-23-19q-32-11-50-14.5t-35-3.5q-19 0-40.5 4.5T265 744q-15 5-24 19t-9 32v14Zm336-67h170v-50H568v50Zm-214-50q23 0 38.5-15.5T408 638q0-23-15.5-38.5T354 584q-23 0-38.5 15.5T300 638q0 23 15.5 38.5T354 692Zm214-63h170v-50H568v50ZM437 436h87V236h-87v200Z" />
            </svg>
            <svg class="w-8 h-8" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M4.5 17q-.625 0-1.062-.438Q3 16.125 3 15.5v-11q0-.625.438-1.062Q3.875 3 4.5 3H10v1.5H4.5v11H10V17Zm9-3.5-1.062-1.062 1.687-1.688H8v-1.5h6.125l-1.687-1.688L13.5 6.5 17 10Z" />
            </svg>
          </button>
        </div>
      </div>
    </div>


    <div v-if="!isLoading" class="px-3 sm:px-4 max-w-5xl"
      :class="[ client_info.wallboxStatus=='idle'||client_info.wallboxStatus=='loading_planned'||client_info.wallboxStatus=='loading'||client_info.wallboxStatus=='loading_paused'||client_info.wallboxStatus=='wait_unlock' ? 'my-[17rem] sm:my-[17rem]' : 'my-56 sm:my-60' ]">
      <div v-for="idx in navlist"
        class="w-full bg-skin-b-list-back border border-skin-b-list-bord shadow mt-4 rounded-lg" :key="idx">

        <a href="#" @click="polling=false" class="relative w-full inline-flex items-center 
        justify-start py-6 pl-6 pr-12 
        overflow-hidden font-semibold 
        text-skin-b-list-base transition-all duration-200 ease-in-out sm:hover:pl-16 sm:hover:pr-6 group">

          <router-link :to="idx.target">
            <span class="absolute bottom-0 left-0 w-full h-full transition-all duration-200 ease-in-out 
          rounded-lg sm:group-hover:bg-skin-active128/10"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out sm:group-hover:translate-x-12">
              <svg class="w-8 h-8 text-skin-base" fill="currentColor" viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg">
                <path d="m6 18-1.417-1.417L11.167 10 4.583 3.417 6 2l8 8Z"></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-4 sm:-translate-x-14 sm:group-hover:translate-x-0 ease-out duration-200">
              <svg class="-mt-1 w-10 h-10" fill="currentColor" :viewBox="idx.viewboxIcon"
                xmlns="http://www.w3.org/2000/svg">
                <path :d="idx.icon"></path>
              </svg>
            </span>
            <span v-if="idx.title==this.t('menu.settings')&&this.$store.state.NewSW"
              class="absolute flex h-3 w-3 top-2.5 -translate-x-4 sm:group-hover:-translate-x-14 ease-out duration-200">
              <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-sky-400 opacity-75"></span>
              <span class="relative inline-flex rounded-full h-3 w-3 bg-sky-500"></span>
            </span>
            <span
              class="relative w-full pl-10 sm:pl-0 text-left text-xl sm:text-2xl duration-200 ease-out sm:group-hover:font-bold">{{
              idx.title }}</span>

            <span v-if="idx.id==1&&this.meshsize>0" class="hidden sm:inline-block 
            text-skin-b-list-mute text-left text-xl sm:text-2xl duration-200 ease-out sm:group-hover:font-bold
          ">&nbsp;&bull;&nbsp;{{ $t('menu.submesh', { Number: this.meshsize }) }}</span>
            <span v-if="idx.id==1&&this.meshsize>0" class="inline-block sm:hidden 
            text-skin-b-list-mute text-left text-xl sm:text-2xl duration-200 ease-out sm:group-hover:font-bold
          ">&nbsp;({{ this.meshsize }})</span>
            <span v-if="idx.title==this.t('menu.settings')&&this.$store.state.NewSW" class="hidden sm:inline-block 
            text-skin-b-list-mute text-left text-xl sm:text-2xl duration-200 ease-out sm:group-hover:font-bold
          ">&nbsp;&bull;&nbsp;{{ $t('menu.subsettings') }}</span>
            <span v-if="idx.title==this.t('menu.settings')&&this.$store.state.NewSW" class="inline-block sm:hidden 
            text-skin-b-list-mute text-left text-base sm:text-xl duration-200 ease-out sm:group-hover:font-bold
          ">&nbsp;({{ $t('menu.subsettingsshort') }})</span>
          </router-link>
        </a>
      </div>
    </div>

    <!-- Modal for stop charging -->
    <MultiModal :show="stopchargingshow" @close="stopchargingshow=false">
      <template #header>
        <IconSpinner v-if="stopspin" class="w-8 h-8 mr-2" />
        <IconError v-else class="w-8 h-8 mr-2" />
        {{ client_info.wallboxStatus==='loading_planned' ? $t('main.deleteplannedcharging') : $t('main.stopcharging') }}
      </template>
      <div class="text-lg font-semibold text-center">
          {{ client_info.wallboxStatus==='loading_planned' ? $t('main.deletetxt') : $t('main.stoptxt') }}
      </div>
      <template #footer>
        <BlueButton :disabled="stopspin" @click="stopchargingshow=false">
          {{ $t('common.cancel') }}
        </BlueButton>
        <RedButton :disabled="stopspin" @click="StopCharging(this.$store.state.WbId,chargerfid);stopspin=true;">
          {{ client_info.wallboxStatus==='loading_planned' ? $t('common.delete') : $t('main.stop') }}
        </RedButton>
      </template>
    </MultiModal>

  </SrcBackgroundScroll>

      <!-- Modal for authentication charging -->
    <MultiModal :show="authchargingshow" @close="authchargingshow=false">
      <template #header>
        <IconSpinner v-if="startspin" class="w-8 h-8 mr-2" />
        <IconError v-else class="w-8 h-8 mr-2" />
        {{ $t('main.authcharging') }}
      </template>
      <template v-if="client_pairings.length">
          <div class="relative overflow-y-auto shrink 
          h-min max-h-48 sm:max-h-96">
              <ul class="">
                  <!-- @click="StartCharging(this.$store.state.WbId,pair.token);startspin=true;" -->
                  <li v-for="(pair, index) in client_pairings.filter(card => card.status === 'active')" :key="index" 
                  @click="opttoken=pair.token;authchargingshow=false;optionchargingshow=true;" 
                  class="cursor-pointer rounded
                          odd:bg-white
                          even:bg-slate-50
                          text-slate-700
                          hover:text-yellow-900 hover:bg-yellow-200">


                      <div class="p-3 sm:p-2 flex items-center group">

                      <div
                        v-if="pair.alias"
                        class="flex-shrink-0 mr-4 rounded-lg border border-slate-300"
                        :style="{ backgroundColor: pair.color }"
                      >
                        <p class="w-10 h-10 px-1 py-2 text-center">
                          <span class="text-base font-semibold text-white">{{ pair.alias }}</span>
                        </p>
                      </div>
                      <div v-else class="flex-shrink-0 mr-4 rounded-lg border border-slate-300" :style="{ backgroundColor: pair.color }">
                        <IconCar class="m-1 w-8 h-8" fill="#ffffff" />
                      </div>


                          <div class="grow">
                              <div class="font-bold text-base truncate">
                                  <span v-if="pair.name">{{ pair.name }} - </span>
                                  <span>{{ pair.info }}</span>
                                  <span v-if="pair.relation!=''">&nbsp;&#8231;&nbsp;</span>
                                  <span v-if="pair.relation!=''" v-html="pair.relation"></span>
                              </div>
                          </div>
                      </div>
                  </li>
              </ul>
          </div>
      </template>
      <template #footer>
        <BlueButton :disabled="startspin" @click="authchargingshow=false">
          {{ $t('common.cancel') }}
        </BlueButton>
      </template>
    </MultiModal>

      <!-- Modal for charging options -->
    <MultiModal :show="optionchargingshow" @close="optionchargingshow=false;resetoptcharge();">
      <template #header>
        <IconSpinner v-if="startspin" class="w-8 h-8 mr-2" />
        <IconError v-else class="w-8 h-8 mr-2" />
        {{ $t('main.optionforcharging') }}
      </template>
      <div class="relative overflow-y-auto">
          <ButtonTabs v-model="selectedTab" :options="tabs" @change="onTabsChange" />
          <OptSlider v-model="addhours" :min="0" :max="47" :step="1" :showTooltip="false"
          class="px-6 mt-4 mb-8"
          >
            <template #label>{{optChargingTime.label}}</template>
          </OptSlider>
          <ButtonTabs v-model="chargeMode" 
              :options="[{ label: this.$t('main.normalcharging'), value: 'Fast' },{ label: this.$t('main.solarcharging'), value: 'Solar', disabled: !solarcharge }]" 
               />
          <OptSlider v-if="chargeMode=='Fast'" v-model="optpower" :min="6" :max="optpowermax" :step="1" :showTooltip="false"
          class="px-6 mt-4 mb-8"
          >
            <template #label>

              {{ $t('main.optchargepower_a', { power: $n( optpower*optphase*230/1000, 'decimal' ), ampere: optpower } ) }}
              <span 
                  class="cursor-pointer underline text-sky-600 hover:text-sky-800"
                  @click="optphase = this.optphase === 1 ? 3 : 1">{{ $t('main.optchargepower_b', { phase: optphase } ) }}</span>)
            </template>
          </OptSlider>
          <label v-if="chargeMode=='Solar'" class="block my-8 text-center text-xl font-bold text-slate-700">
                {{ $t('main.solarchargingtxt') }}
          </label>
          <ButtonTabs v-model="chargeLimits" 
              :options="[{ label: this.$t('main.opttimelimit'), value: 'duration' }, { label: this.$t('main.optpowerlimit'), value: 'amount' }]" 
               />
          <OptSlider v-if="chargeLimits=='duration'" v-model="optduration" :min="0" :max="12" :step="1" :showTooltip="false"
          class="px-6 my-4"
          >
            <template #label>{{optduration === 0 ? this.$t('main.optunlimited') : this.$t('main.opttimelimittxt', { hour: optduration } )}}
            </template>
          </OptSlider>
          <OptSlider v-if="chargeLimits=='amount'" v-model="optamount" :min="0" :max="12" :step="1" :showTooltip="false"
          class="px-6 my-4"
          >
            <template #label>{{optamount === 0 ? this.$t('main.optunlimited') : this.$t('main.optpowerlimittxt', { power: optamount*5 } )}}
            </template>
          </OptSlider>
          </div>
      <template #footer>
        <BlueButton :disabled="startspin" @click="optionchargingshow=false;resetoptcharge();">
          {{ $t('common.cancel') }}
        </BlueButton>
        <BlueButton :disabled="startspin" @click="StartCharging">
          {{ addhours==0 ? $t('main.authcharging') : $t('main.authplan') }}
        </BlueButton>  
      </template>
    </MultiModal>

</template>

<script>
import { useI18n } from 'vue-i18n'
import SrcBackgroundScroll from './sources/SrcBackgroundScroll.vue'
import MultiModal from './elements/MultiModal.vue'
import IconError from './icons/IconError.vue'
import IconSpinner from './icons/IconSpinner.vue'
import IconCar from './icons/IconCar.vue'
import ButtonTabs from './elements/ButtonTabs.vue'
import OptSlider from './elements/OptSlider.vue'
import BlueButton from './sources/SrcBlueButton.vue'
import RedButton from './sources/SrcRedButton.vue'

export default {
  components: {
    SrcBackgroundScroll, MultiModal, IconError, IconSpinner, IconCar,
    BlueButton, RedButton, ButtonTabs, OptSlider
  },
  name: 'MainPage',
  setup () {
    const { t,d,n } = useI18n()
    return { t,d,n }
  },
  data() {
    return {
      polling: true,     
      logbox: true,
      navlist: [],
      svgdata: [
        {wb_housingtop:'m40 2c-6.6391 0-14.498228.0082969-15.986328.1542969-1.488.14587-2.604663.5780856-3.664063 1.3847656-1.0968.83516-2.297662 2.217115-2.976562 3.421875-.183688.3259747-.345767.6800343-.498047 1.0390625h46.324219c-.169624-.4363957-.360309-.8543302-.572266-1.2304688-.6789-1.2047699-1.879762-2.3953087-2.976562-3.2304687-1.0594-.80668-2.176063-1.2388956-3.664063-1.3847656-1.4881-.14588-9.347228-.1542969-15.986328-.1542969z'},
        {wb_housing:'m16.875 0c-.541357 1.2763508-.875 2.6889039-.875 3.7695312v54.2304688c0 1.61539.485147 3.307544 1.373047 4.115234 0 0 2.634028 2.346908 3.548828 2.923828.9147.576931 2.976259.544947 4.693359.691407 1.717.14646 4.883966.269531 14.384766.269531s12.667766-.123071 14.384766-.269531c1.7171-.14646 3.778659-.114476 4.693359-.691407.9148-.576919 3.548828-2.923828 3.548828-2.923828.8879-.80769 1.373047-2.499844 1.373047-4.115234v-54.2304688c0-1.033847-.300814-2.4832514-.800781-3.7695312zm14.9375.82421875c1.2022-.001 2.450469-.00096 3.667969 0 1.6233.001 3.191731.001953 4.519531.001953s2.896231-.00095313 4.519531-.001953c1.2175-.00096 2.465769-.001 3.667969 0 3.6066.004 6.795244.0219906 7.464844.0878906 1.1905.11669005 2.577081.41688685 3.425781 1.06054685.8525.6464501 1.302356 1.0680138 2.097656 2.3085938.7953 1.24057.886719 3.407945.886719 4.515625v47.806641c0 1.29231-.580616 2.646818-1.291016 3.292968 0 0-1.342418 1.300179-2.074218 1.761719s-.854916.628924-2.228516.746094c-1.3736.11716-8.86815.02344-16.46875.02344s-15.09515.09376-16.46875-.02344c-1.3736-.11717-1.496716-.284554-2.228516-.746094s-2.074218-1.761719-2.074218-1.761719c-.7104-.64615-1.291016-2.000658-1.291016-3.292968v-47.806641c0-1.10768.09152-3.275055.886719-4.515625.7953-1.24058 1.245156-1.6621438 2.097656-2.3085938.8487-.64366 2.235281-.9438568 3.425781-1.06054682.6696-.0656 3.858244-.0841906 7.464844-.0878906zm-3.259766 14.33007825c-1.8496 0-3.33789 1.500814-3.33789 3.365234v34.134766c0 1.86442 1.48829 3.365234 3.33789 3.365234h22.894532c1.8496 0 3.33789-1.500814 3.33789-3.365234v-34.134766c0-1.86442-1.48829-3.365234-3.33789-3.365234zm0 .480469h22.894532c1.5936 0 2.861328 1.278375 2.861328 2.884765v34.134766c0 1.6064-1.267728 2.884765-2.861328 2.884765h-22.894532c-1.5936 0-2.861328-1.278365-2.861328-2.884765v-34.134766c0-1.60639 1.267728-2.884765 2.861328-2.884765z'},
        {wb_leds:'m40 22.74988c-.6575 0-1.1935.53963-1.1935 1.20192 0 .6623.536 1.20193 1.1935 1.20193s1.1935-.53963 1.1935-1.20193c0-.66229-.536-1.20192-1.1935-1.20192zm-2.8431.26724c-.511.00001-.9283.4199-.9283.93468 0 .5148.4173.93487.9283.93488.5111.00001.9282-.42008.9282-.93488 0-.51479-.4171-.93469-.9282-.93468zm5.6862 0c-.5111-.00001-.9282.41989-.9282.93468 0 .5148.4171.93489.9282.93488.511-.00001.9283-.42008.9283-.93488 0-.51478-.4173-.93467-.9283-.93468zm-7.9988.26706c-.3645-.00001-.6631.30034-.6631.66762 0 .3673.2986.66783.6631.66782.3645 0 .6629-.30053.6629-.66782 0-.36727-.2984-.66762-.6629-.66762zm10.3114 0c-.3645 0-.6629.30035-.6629.66762 0 .36729.2984.66782.6629.66782.3645.00001.6631-.30052.6631-.66782 0-.36728-.2986-.66763-.6631-.66762z'},
        {wb_rfidlogo:'M 94.996094,15.290038 C 90.330866,19.955274 88,25.955942 88,31.954102 c 0,5.998162 2.330866,11.99492 6.996094,16.660156 l 2.667968,-2.664062 C 93.998526,41.951422 92,36.95257 92,31.954102 c 0,-4.998466 1.998526,-9.99732 5.664062,-13.996094 z m 50.007806,0 -2.66796,2.66797 C 146.00148,21.956782 148,26.955636 148,31.954102 c 0,4.998468 -1.99852,9.997318 -5.66406,13.996094 l 2.66796,2.664062 C 149.66914,43.949022 152,37.952264 152,31.954102 c 0,-5.99816 -2.33086,-11.998828 -6.9961,-16.664064 z m -44.67578,5.66797 c -2.999072,2.99908 -4.664058,6.997322 -4.664058,10.996094 0,3.998774 1.664986,7.997014 4.664058,10.996094 l 2.66797,-2.66797 c -2.33261,-2.332618 -3.332028,-5.329042 -3.332028,-8.328124 0,-2.99908 0.999418,-5.999414 3.332028,-8.332032 z m 39.34376,0 -2.66798,2.664062 c 2.33262,2.332618 3.33204,5.332952 3.33204,8.332032 0,2.079482 -0.5169,4.142942 -1.58984,6 v -0.722658 l -5.53126,-5.585936 v -5.3125 c 0,-1.893904 -1.53234,-3.445314 -3.41796,-3.445312 h -19.34766 c -1.88563,0 -3.41797,1.551408 -3.41797,3.445312 v 11.167968 c 0,1.893904 1.53234,3.44531 3.41797,3.445312 h 10.28906 L 132.2539,54.90332 h 12.01954 v -0.652344 -3.0625 L 138.7461,45.606444 V 42.02832 l 0.92578,0.921876 c 2.99908,-2.999084 4.66406,-6.99732 4.66406,-10.996094 0,-3.998772 -1.66498,-7.997014 -4.66406,-10.996094 z m -29.22266,3.234374 h 19.34766 c 1.17732,0 2.11328,0.941192 2.11328,2.140626 v 3.996094 7.171874 c 0,0.863196 -0.49316,1.577442 -1.20312,1.917968 -0.1164,0.04618 -0.22264,0.0749 -0.32814,0.10156 -0.1882,0.05436 -0.37504,0.11718 -0.58202,0.11718 h -1.36328 l -4.4961,-5.35547 -0.008,-0.0078 c -0.94206,-1.070044 -1.9247,-1.706184 -2.875,-1.957032 -0.95028,-0.250848 -1.87354,-0.09248 -2.55859,0.398438 -1.37014,0.981838 -1.62789,3.129898 -0.30079,5.144532 l 0.0196,0.02734 1.44532,1.75 h -9.21094 c -1.17732,0 -2.11328,-0.937286 -2.11328,-2.13672 V 26.333004 c 0,-1.199434 0.93596,-2.140626 2.11328,-2.140626 z m 22.76562,9.3125 4.22266,4.26172 v 8.375 l 5.52734,5.585936 v 1.871094 H 132.8711 L 119.27734,37.12207 c -1.05166,-1.610442 -0.71727,-2.843668 -0.0196,-3.34375 0.35034,-0.251044 0.83086,-0.36266 1.46484,-0.19532 0.63358,0.16724 1.41426,0.63257 2.22658,1.554688 l 4.875,5.808592 h 1.21092 0.76172 c 0,0 0.22024,-4.64e-4 0.54298,-0.05468 0.131,-0.02126 0.25722,-0.05396 0.3828,-0.08984 0.0888,-0.0233 0.1746,-0.05376 0.26954,-0.08594 0.0688,-0.02608 0.1366,-0.05168 0.20312,-0.08204 0.094,-0.03784 0.1856,-0.06104 0.28126,-0.10938 0.5755,-0.29061 1.14882,-0.86099 1.47266,-1.6875 0.0578,-0.14748 0.1058,-0.299514 0.1446,-0.464844 0.0734,-0.280224 0.121,-0.568444 0.121,-0.871094 z'},
        {cable_carconnect:'m38.5 66v40.99982c0 7.71422 6.2858 14 14 14s14-6.28578 14-14v-4.75195c0-.9722.4708-1.83762 1.1934-2.38672l.3066.51172c1.5-1.125 5.25-3.75 7.125-3.75h9.875c.554 0 1-.446 1-1v-5c0-.554-.446-1-1-1h-9.875c-3.75-.018-7.875 5.125-9.375 7l.3906.65234c-1.5937 1.0783-2.6406 2.90246-2.6406 4.97266v4.75195c0 6.0929-4.9071 11-11 11s-11-4.9071-11-11v-40.99982z'},
        {cable_wbconnect:'m64 47.00305c-.554 0-1 .446-1 1v5c0 .554.446 1 1 1h9.875c1.875 0 5.625 2.625 7.125 3.75l.3066-.51172c.7226.5491 1.1934 1.41452 1.1934 2.38672v26.75195h-.016c0 11.3396-9.1604 20.5-20.5 20.5s-20.5-9.1604-20.5-20.5h.016v-20.38h-3v20.38h-.016c0 12.96092 10.5391 23.5 23.5 23.5s23.5-10.53908 23.5-23.5h.016v-26.75195c0-2.0702-1.0469-3.89436-2.6406-4.97266l.3906-.65234c-1.5-1.875-5.625-7.018-9.375-7z'},
        {car_full:'m126.91666 67.00187c-8.93316.0353-24.90416.77704-37.260232 4.08008-1.225077.32751-2.183637 1.1126-3.273605 2.10352s-2.244641 2.22879-3.435716 3.5664c-2.382349 2.67524-4.912908 5.76014-6.998538 7.86328l-.035.0332-.031.0371c-1.462791 1.68073-1.499094 3.98231-1.648503 6.51757-.147509 2.50206-.16641 5.20687-.421926 7.21094-.934559 3.10036-2.157836 5.43439-1.720808 8.19727.0002.001-.0002.003 0 .004.878255 6.064 2.068229 9.33158 3.939647 11.23633 1.874317 1.90758 4.251866 1.9375 6.144985 1.9375h1.544997c2.050929 4.32112 6.333197 7.20457 11.188201 7.21094 4.857205-.004 9.140268-2.88788 11.192098-7.21094h54.71833c2.05073 4.32147 6.333 7.20457 11.1882 7.21094 4.85721-.004 9.14217-2.88784 11.194-7.21094h.85166c2.75357 0 5.90107.005 8.79155-.35547l.02-.002.02-.004c1.05747-.16034 2.59976-.37546 4.02566-.91992.71285-.27223 1.41629-.62393 2.01762-1.20508.60105-.58075 1.06947-1.48143 1.06257-2.45507.017-4.12063.052-9.14414-.34373-11.72266-1.01975-6.81654-4.30607-10.53846-8.1392-13.49219l-.082-.0625-.088-.0508c-2.15523-1.23148-5.29903-2.06117-8.79545-2.88476-3.49652-.8236-7.30946-1.5882-10.50456-2.41602l-.039-.01-.041-.008c-1.70731-.34392-3.1046-.70752-3.71514-1.3125l-.082-.082-.094-.0664c-15.24065-11.05792-21.61235-12.8365-25.85522-13.9707-4.21106-1.12574-6.3766-1.80286-15.30166-1.76758z'},
        {car_line:'m126.91666 67.00187c-8.93316.0353-24.90416.77704-37.260232 4.08008-1.225077.32751-2.183637 1.1126-3.273605 2.10352s-2.244641 2.22879-3.435716 3.5664c-2.382349 2.67524-4.912908 5.76014-6.998538 7.86328l-.035.0332-.031.0371c-1.462791 1.68073-1.499094 3.98231-1.648503 6.51757-.147509 2.50206-.16641 5.20687-.421926 7.21094-.934559 3.10036-2.157836 5.43439-1.720808 8.19727.0002.001-.0002.003 0 .004.878255 6.064 2.068229 9.33158 3.939647 11.23633 1.874317 1.90758 4.251866 1.9375 6.144985 1.9375h1.544997c2.050929 4.32112 6.333197 7.20457 11.188201 7.21094 4.857205-.004 9.140268-2.88788 11.192098-7.21094h54.71833c2.05073 4.32147 6.333 7.20457 11.1882 7.21094 4.85721-.004 9.14217-2.88784 11.194-7.21094h.85166c2.75357 0 5.90107.005 8.79155-.35547l.02-.002.02-.004c1.05747-.16034 2.59976-.37546 4.02566-.91992.71285-.27223 1.41629-.62393 2.01762-1.20508.60105-.58075 1.06947-1.48143 1.06257-2.45507.017-4.12063.052-9.14414-.34373-11.72266-1.01975-6.81654-4.30607-10.53846-8.1392-13.49219l-.082-.0625-.088-.0508c-2.15523-1.23148-5.29903-2.06117-8.79545-2.88476-3.49652-.8236-7.30946-1.5882-10.50456-2.41602l-.039-.01-.041-.008c-1.70731-.34392-3.1046-.70752-3.71514-1.3125l-.082-.082-.094-.0664c-15.24065-11.05792-21.61235-12.8365-25.85522-13.9707-4.21106-1.12574-6.3766-1.80286-15.30166-1.76758zm.012 2.99414c8.78396-.0347 10.24885.52516 14.51651 1.66602 4.23607 1.13239 9.82042 2.58016 24.87066 13.5l-.17381-.14844c1.5333 1.51953 3.55963 1.78601 5.23273 2.12305 3.30231.85217 7.08815 1.61151 10.48706 2.41211 3.38821.7981 6.4021 1.68997 7.9262 2.54297 3.51322 2.72304 6.00267 5.44471 6.90473 11.47461v.004.002c.29182 1.89998.32702 7.16338.31052 11.27929v.01.008c0 .12856.01.12624-.15031.28125-.16041.15501-.52263.37597-1.00596.56055-.96006.3666-2.32725.59162-3.38302.75195-2.61366.32455-5.65635.33203-8.40482.33203h-2.75798l-.35942.98047c-1.37298 3.74184-4.93061 6.22636-8.92826 6.23047-3.99675-.005-7.55187-2.48962-8.92446-6.23047l-.36132-.98047h-58.52907l-.36132.98047c-1.37269 3.74119-4.929512 6.22551-8.926362 6.23047-3.996751-.005-7.553774-2.48962-8.92636-6.23047l-.359323-.98047h-3.451416c-1.893119 0-2.958486.0292-4.010052-1.04101-1.051565-1.07024-2.271142-3.75821-3.113495-9.58789v-.01-.01c-.242715-1.52909.669042-3.60732 1.677905-7.01562l.033-.11328.016-.11524c.308219-2.33451.305419-5.1157.447328-7.52343.141808-2.40774.677742-4.45254.917957-4.72852l-.066.0723c2.258542-2.27749 4.7897-5.37504 7.109846-7.98047 1.160073-1.30272 2.265642-2.48044 3.213101-3.3418.94746-.86136 1.803813-1.36443 2.033328-1.42578 11.835643-3.16394 27.722633-3.94383 36.498383-3.97852z'},
        {car_linebattery:'m126.90933 67.00177c-8.9345.0357-24.8992.77792-37.252004 4.08008-1.2251.32751-2.1854 1.1126-3.2754 2.10352s-2.2444 2.22879-3.4355 3.5664c-2.3824 2.67524-4.9124 5.76014-6.9981 7.86328l-.035.0332-.031.0371c-1.4627 1.68073-1.499 3.98232-1.6484 6.51757-.1475 2.50208-.1664 5.20687-.4219 7.21094-.9345 3.10036-2.1577 5.43439-1.7207 8.19727.0002.001-.0002.003 0 .004.8783 6.064 2.068 9.33158 3.9394 11.23633 1.8743 1.90758 4.2534 1.9375 6.1465 1.9375h1.545c1.4021 2.95418 3.8467 5.23444 6.8046 6.38477-.3372-.76839-.5273-1.61236-.5273-2.49805v-1.03906c-1.8129-1.09298-3.2508-2.78217-4.0137-4.86133l-.3593-.98047h-3.4532c-1.8931 0-2.9581.0292-4.0097-1.04101-1.0516-1.07024-2.271-3.75821-3.1133-9.58789v-.01-.01c-.2427-1.52909.6688-3.60732 1.6777-7.01562l.033-.11328.016-.11524c.3082-2.33451.3054-5.1157.4473-7.52343.1413-2.39844.6725-4.4322.9141-4.72071 2.2434-2.2717 4.749-5.33334 7.0488-7.91601 1.1601-1.30272 2.2655-2.48044 3.2129-3.3418.9475-.86136 1.8036-1.36443 2.0332-1.42578 11.834804-3.16373 27.720004-3.94373 36.496104-3.97852 8.7821-.0346 10.2464.52525 14.5137 1.66602 4.236 1.13239 9.8209 2.58016 24.8711 13.5 1.5111 1.37855 3.4461 1.64979 5.0585 1.97461 3.3023.85217 7.0894 1.61151 10.4883 2.41211 3.3882.7981 6.4017 1.68997 7.9258 2.54297 3.5132 2.72304 6.0023 5.44471 6.9043 11.47461v.004.002c.2918 1.89998.3271 7.16338.3106 11.27929v.01.008c0 .12856.01.12624-.1504.28125s-.5226.37597-1.0059.56055c-.9601.3666-2.3271.59162-3.3828.75195-2.6137.32455-5.6558.33203-8.4043.33203h-2.7578l-.3594.98047c-1.373 3.74184-4.9321 6.22636-8.9297 6.23047-3.9968-.005-7.5512-2.48962-8.9238-6.23047l-.3613-.98047h-41.7272v2.99414h39.8203c2.0507 4.32147 6.3323 7.20457 11.1875 7.21094 4.8572-.004 9.1434-2.88784 11.1953-7.21094h.8516c2.7536 0 5.9005.005 8.791-.35547l.02-.002.021-.004c1.0574-.16034 2.5995-.37546 4.0254-.91992.7129-.27223 1.4162-.62393 2.0176-1.20508.601-.58075 1.0694-1.48143 1.0625-2.45507.017-4.12063.052-9.14414-.3438-11.72266-1.0198-6.81654-4.3055-10.53846-8.1386-13.49219l-.082-.0625-.09-.0508c-2.1553-1.23148-5.2984-2.06117-8.7949-2.88476-3.4965-.8236-7.3088-1.5882-10.5039-2.41602l-.039-.01-.041-.008c-1.7073-.34392-3.1043-.70752-3.7149-1.3125l-.082-.082-.094-.0664c-15.2406-11.05792-21.6126-12.8365-25.8555-13.9707-4.2098-1.12538-6.377-1.80239-15.2949-1.76758zm-26.4102 9.99805v5h-4.175804c-1.825 0-3.3242 1.49921-3.3242 3.32422v38.35156c0 1.82501 1.4997 3.32422 3.3496 3.32422h18.326204c1.825 0 3.3242-1.49962 3.3242-3.34961v-38.32617c0-1.82501-1.4992-3.32422-3.3242-3.32422h-4.1758v-5zm-3.500004 8h17.000004c.5523.00006.9999.44774 1 1v37c-.0001.55226-.4477.99994-1 1h-17.000004c-.5523-.00006-.9999-.44774-1-1v-37c.0001-.55226.4477-.99994 1-1z'}
      ],
      wbselectshow: false,
      freecharging: false,
      solarcharge: false,
      solarchargemode: 'Fast',
      charging: false,
      chargecurrent: 0,
      chargepower: 0,
      maxchargepower: 0,
      donutmaxchargepower: 22080,
      donutchargepower: 0,
      midavailable: false,
      stopchargingshow: false,
      authchargingshow: false,
      optionchargingshow: false,
      tabs: [{ label: this.$t('common.immediately'), value: 'now' }, { label: this.$t('common.today'), value: 'today' }, { label: this.$t('common.tomorrow'), value: 'tomorrow' }],
      selectedTab: 'now',
      addhours: 0,      
      chargeMode: 'Fast',
      optpower: 6,
      optpowermax: 16,
      optphase: 3,
      optsolar: false,
      optphaseone: false,         
      chargeLimits: 'duration',
      optduration: 0,
      optamount: 0,
      opttoken: '',
      authmode: 'Fast',
      stopspin: false,
      startspin: false,
      chargerfid: '',
      chargerfidinfo: '',
      chargeusername: '',
      chargecolor: '#6b7280',
      chargestarttime: '',
      loadedenergy: 0,
      loadtime: '',
      energytotal: 0,
      statinternet: undefined,
      statdlm: undefined,
      statp14: undefined,
      statocpp: 'disabled',
      statocppdlm: 'disabled',
      statwlan: -1,
      statlte: -1,  
      clients_list: [],
      client_info: [],
      client_status: [],      
      client_setting: [],
      client_schedule: [],
      client_mid: [],
      client_pairings: [],
      client_statistic: [],
      client_userlist: [],
      sections: [
          { label: 'Ladestrom', value: 0, color: 'rgb(var(--color-active-hsl-128))' }
        ],
      errorcodetxt: '',
      errorcodetabelle: [{error:'Car', errortext:this.$t('errortxt.Car')},
                        {error:'CarDiodeFault', errortext:this.$t('errortxt.CarDiodeFault')},
                        {error:'Relais', errortext:this.$t('errortxt.Relais')},
                        {error:'RCD', errortext:this.$t('errortxt.RCD')},
                        {error:'VentilationNotAvailable', errortext:this.$t('errortxt.VentilationNotAvailable')},
                        {error:'OverCurrent', errortext:this.$t('errortxt.OverCurrent')},
                        {error:'Internal', errortext:this.$t('errortxt.Internal')},
                        {error:'SLAC', errortext:this.$t('errortxt.SLAC')},
                        {error:'HLC', errortext:this.$t('errortxt.HLC')},
                        {error:'Socket', errortext:this.$t('errortxt.Socket')},
                        {error:'PP_PE', errortext:this.$t('errortxt.PPPE')},
                        {error:'Disabled', errortext:this.$t('errortxt.Disabled')},
                      ],
      meshsize: 0,
      isLoading: false,
      loader: "spinner",
      loadercolor: 'rgb(var(--color-active-hsl-128))',
      loaderbackcolor: 'rgb(var(--color-b-back))',
      isShrunk: false,
    }
  },
  computed: {
    optChargingTime() {
      const now = new Date();
      const H = now.getHours();
      const M = now.getMinutes();
      const pad2 = (n) => String(n).padStart(2, '0');
      const clock = this.$t('main.chargestarttime');

      if (this.addhours === 0) {
        // addhours = 0 → aktuelle Uhrzeit HH:MM Uhr, Tab 'now'
        return {
          label: `${pad2(H)}:${pad2(M)}${clock}`,
          tab: 'now'
        };
      }

      // Basisstunde (hier bewusst nicht aufrunden)
      const baseHour = H;
      const totalHours = baseHour + Number(this.addhours);
      const isTomorrow = totalHours >= 24;
      const hour = ((totalHours % 24) + 24) % 24;


      const prefix = isTomorrow ? this.$t('common.tomorrow')+', ' : this.$t('common.today')+', ';
      const label = `${prefix}${pad2(hour)}:00${clock}`;

      // Lokales Zieldatum bestimmen
      const localDate = new Date(now);
      if (isTomorrow) {
        localDate.setDate(localDate.getDate() + 1);
      }

      // Ein einziges Date-Objekt für die gewünschte lokale Stunde (00 Minuten, 00 Sekunden)
      const localAtHour = new Date(
        localDate.getFullYear(),
        localDate.getMonth(),
        localDate.getDate(),
        hour,
        0, 0, 0
      );

      // Vollständiger Zeitstempel YYYY-MM-DD HH:MM:00 (lokale Zeit)
      //const timestamp =
      //  `${localAtHour.getFullYear()}-${pad2(localAtHour.getMonth() + 1)}-${pad2(localAtHour.getDate())}` +
      //  `%20${pad2(localAtHour.getHours())}:00:00`;

      // UTC-Zeitstempel im selben Format (gleicher Moment, nach UTC verschoben)
      const timestamp =
        `${localAtHour.getUTCFullYear()}-${pad2(localAtHour.getUTCMonth() + 1)}-${pad2(localAtHour.getUTCDate())}` +
        `%20${pad2(localAtHour.getUTCHours())}:00:00`;

      return {
        label,
        tab: isTomorrow ? 'tomorrow' : 'today',
        timestamp
      };
    },
  },

  watch: {
    // Wenn sich addhours ändert, Tab entsprechend setzen
    addhours: {
      immediate: true,
      handler() {
        this.selectedTab = this.optChargingTime.tab
      }
    }
  },  
  methods: {
    decodeHtml: function(html) {
      let txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    },
    copyToClipBoard(textToCopy){
      navigator.clipboard.writeText(textToCopy);      
    },
    logout(){
      this.axios
          .get('wallbox/login.php?action=logout&user='+this.$store.state.token)
          .then((response) => {
            if(response.data.status=='ok'){
              this.$router.push({path: '/'});
            }else{
              console.log('Error logout commando');
            }
          })                
          .catch((errors) => {
              console.error(errors);
          });      
    },
    SolarchargeOn(rfidtoken){
      if(rfidtoken=='##FREE_CHARGING##')
        rfidtoken = '-1';
      this.polling = false;
      this.axios
          //.get('wallbox/charging.php?action=schedule_charging&user='+this.$store.state.token+'&card='+rfidtoken+'&option=Solar')
          .get('wallbox/charging.php?action=change_mode_charging&user='+this.$store.state.token+'&option=Solar')
          .then((response) => {
            if(response.data.status=='ok'){
              this.updatepage();
            }else{
              console.log('Error send Solar');
            }
          })                
          .catch((errors) => {
              console.error(errors);
          });        
    },
    SolarchargeOff(rfidtoken){
      if(rfidtoken=='##FREE_CHARGING##')
        rfidtoken = '-1';
      this.polling = false;
      this.axios
          //.get('wallbox/charging.php?action=schedule_charging&user='+this.$store.state.token+'&card='+rfidtoken+'&option=Fast')
          .get('wallbox/charging.php?action=change_mode_charging&user='+this.$store.state.token+'&option=Fast')
          .then((response) => {
            if(response.data.status=='ok'){
              this.updatepage();
            }else{
              console.log('Error send Fast');
            }
          })                
          .catch((errors) => {
              console.error(errors);
          });        
    },
    async AuthCharging(mode) {
      this.isLoading = true;
      this.authmode = mode;

      const { token, WbId } = this.$store.state;
      const client_pairingsUrl = `wallbox/pairing.php?action=list_pairings&user=${token}&client=${WbId}&typ=charging_token`;
      const usersUrl = `wallbox/user.php?action=user_reload&user=${token}`;

      try {
        const [responseclient_pairings, responseusers] = await Promise.all([
          this.axios.get(client_pairingsUrl),
          this.axios.get(usersUrl),
        ]);

        // ------------------------------------------------------------------
        // PAIRINGS + USERS
        // ------------------------------------------------------------------
        if (
          responseclient_pairings?.data?.status === "token" ||
          responseusers?.data?.status === "token"
        ) {
          this.$router.push({ path: "/" });
          return;
        }

        if (
          responseclient_pairings?.data?.status === "ok" &&
          responseusers?.data?.status === "ok"
        ) {
          const pairings =
            responseclient_pairings.data.tbl_remote_pairing || [];

          const users =
            responseusers.data.tbl_user || [];

          // Build lookup table: { userId: { name, alias, ... } }
          const userMap = users.reduce((acc, user) => {
            acc[user.userId] = user;
            return acc;
          }, {});

          // Enrich pairings with user data
          this.client_pairings = pairings.map(pairing => {
            const user = userMap[pairing.user];

            const rawColor = pairing.color?.trim();

            return {
              ...pairing,
              name: user?.name ? this.decodeHtml(user.name) : "",
              alias: user?.alias ? this.decodeHtml(user.alias) : "",
              info: pairing.info ? this.decodeHtml(pairing.info) : "",
              color: rawColor
                ? rawColor.startsWith("#")
                  ? rawColor
                  : `#${rawColor}`
                : "#6B7280",
            };
          });
          const collator = new Intl.Collator("de-DE", { sensitivity: "base", numeric: true });

          this.client_pairings = [...this.client_pairings].sort((a, b) => {
            const aAlias = (a.alias || "").trim();
            const bAlias = (b.alias || "").trim();
            const aName  = (a.name  || "").trim();
            const bName  = (b.name  || "").trim();
            const aInfo  = (a.info  || "").trim();
            const bInfo  = (b.info  || "").trim();

            // 1) alias first
            const aHasAlias = aAlias.length > 0;
            const bHasAlias = bAlias.length > 0;
            if (aHasAlias !== bHasAlias) return aHasAlias ? -1 : 1;
            if (aHasAlias && bHasAlias) return collator.compare(aAlias, bAlias);

            // 2) then name
            const aHasName = aName.length > 0;
            const bHasName = bName.length > 0;
            if (aHasName !== bHasName) return aHasName ? -1 : 1;
            if (aHasName && bHasName) return collator.compare(aName, bName);

            // 3) finally info
            return collator.compare(aInfo, bInfo);
          });
        }
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      } finally {
        this.resetoptcharge();
        this.isLoading = false;
        this.authchargingshow = true;
      }
    },
    onTabsChange() {
      const now = new Date()
      const H = now.getHours()
      const M = now.getMinutes()
      const baseHour = H

      if (this.selectedTab === 'now') {
        this.addhours = 0
        return
      }

      if (this.selectedTab === 'today') {
        // Nächste volle Stunde HEUTE (mind. 1h, bleibt vor Mitternacht)
        // Beispiel: 08:32 → 09:00 (addhours=1)
        const nextFull = (baseHour % 24);
        this.addhours = Math.max(1, nextFull - H); // mindestens 1 Stunde
        // Falls schon 23:xx → bleibt 23:00 heute (addhours ggf. 0? erzwingen wir 1h)
        if (H >= 23 && M > 0) this.addhours = 1; // 00:00 morgen wäre 'tomorrow', daher hier 1h = 00:00 morgen? -> unten abfangen:
        // Korrektur: Wenn diese Rechnung über 24h ginge, verschiebt der Watcher den Tab automatisch zu 'tomorrow'
      }

      if (this.selectedTab === 'tomorrow') {
        this.addhours = 24 - baseHour
      }
    },
    resetoptcharge(){
    this.addhours = 0;
    this.optduration = 0;
    this.optamount = 0;
    this.chargeMode = this.solarcharge ? 'Solar' : 'Fast';
    },
    async StartCharging() {
        //action=schedule_charging&user=XXX&option={%22mode%22:%22Fast%22,%20%22current%22:%2216000%22,%20%22phases%22:%223%22}&time=2025-10-18%2007:47:00&client=-1&card=12334452
        this.solarchargemode = this.chargeMode === 'Solar' ? 'Solar' : 'Fast';
        let optchargeurl = this.chargeMode === 'Solar' ? 
                                               `{%22mode%22:%22Solar%22}` : 
                                               `{%22mode%22:%22Fast%22,%20%22current%22:%22${this.optpower}000%22,%20%22phases%22:%22${this.optphase}%22,%20%22duration%22:%22${this.optduration*3600}%22,%20%22energy%22:%22${this.optamount*5000}%22}`
        let opttimeurl = this.addhours === 0 ? `-1` : `${this.optChargingTime.timestamp}`;

        this.optionchargingshow = false;
        this.isLoading = true;

        try {
            const response = await this.axios.get(`wallbox/charging.php?action=schedule_charging&option=${optchargeurl}&time=${opttimeurl}&client=${this.$store.state.WbId}&card=${this.opttoken}&user=${this.$store.state.token}`);
            if (response.data.status === 'token') {
                this.$router.push({path: '/'});
            } else if (response.data.status === 'ok') {
                console.log('StartCharging: ok');
            } else {
                console.log(`StartCharging: <${response.data.status}> Error`);
            }
        } catch (error) {
            console.log(error);
        } finally {
            // Wait up to 10 seconds for the wallbox status to change to 'loading'
            const pollInterval = 500; // Check every 500 milliseconds
            const timeout = 10000; // Timeout after 10000 milliseconds (8 seconds)
            const start = Date.now();
            while (Date.now() - start < timeout) {
                const wallboxStatus = this.client_info.wallboxStatus;
                if (wallboxStatus === 'loading_planned' || wallboxStatus === 'loading' || wallboxStatus === 'loading_paused' || wallboxStatus === 'auth_ok') {
                    this.isLoading = false;
                    this.resetoptcharge();
                    this.startspin = false;
                    break;
                }
                await new Promise(resolve => setTimeout(resolve, pollInterval));
            }
    
            // Reset stopping flag if the status did not change within the timeout
            if (this.isLoading) {
                this.isLoading = false;
                this.resetoptcharge();
                this.startspin = false;
                console.log('StartCharging: Wallbox status did not change to "loading" within the timeout period.');
            }
        }
    },
    async StopCharging(id, rfid) {
        if(rfid=='##FREE_CHARGING##')
          rfid = '-1';
        try {
            const response = await this.axios.get(`wallbox/charging.php?action=abort_charging&user=${this.$store.state.token}&client=${id}&card=${rfid}`);
            
            if (response.data.status === 'token') {
                this.$router.push({path: '/'});
            } else if (response.data.status === 'ok') {
                console.log('StopCharging: ok');
            } else {
                console.log(`StopCharging: <${response.data.status}> Error`);
            }
        } catch (error) {
            console.log(error);
        } finally {
            // Wait up to 10 seconds for the wallbox status to change to 'loading_done'
            const pollInterval = 500; // Check every 500 milliseconds
            const timeout = 10000; // Timeout after 10000 milliseconds (8 seconds)
            const start = Date.now();
    
            while (Date.now() - start < timeout) {
                const wallboxStatus = this.client_info.wallboxStatus;
                if (wallboxStatus === 'loading_done' || wallboxStatus === 'idle' || wallboxStatus === 'wait_unlock') {
                    this.stopchargingshow = false;
                    this.stopspin = false;
                    break;
                }
                await new Promise(resolve => setTimeout(resolve, pollInterval));
            }
    
            // Reset stopping flag if the status did not change within the timeout
            if (this.stopchargingshow) {
                this.stopchargingshow = false;
                this.stopspin = false;
                console.log('StopCharging: Wallbox status did not change to "loading_done" within the timeout period.');
            }
        }
    },
    async pollData () {
      if (!this.polling) return;

      console.log('get Polldata main');

      const { Mesh, token, WbId } = this.$store.state;

      const reload_ClientsUrl = Mesh
        ? `wallbox/client.php?action=reload_clients_async&user=${token}`
        : `wallbox/client.php?action=client_info&user=${token}`;

      const client_scheduleUrl = `wallbox/info.php?action=get_schedule&user=${token}&client=${WbId}`;
      const client_midUrl      = `wallbox/info.php?action=get_mid_status&user=${token}&client=${WbId}`;
      const client_statusUrl   = `wallbox/info.php?action=get_status&user=${token}&client=${WbId}`;

      try {
        const [
          responsereload_clients,
          responseclient_schedule,
          responseclient_mid,
          responseclient_status,
        ] = await Promise.all([
          this.axios.get(reload_ClientsUrl),
          this.axios.get(client_scheduleUrl),
          this.axios.get(client_midUrl),
          this.axios.get(client_statusUrl),
        ]);

        // ------------------------------------------------------------------
        // 1) RELOAD CLIENT(S)
        // ------------------------------------------------------------------
        if (Mesh) {
          // MESH MODE
          if (responsereload_clients.data.status === 'ok') {
            const tbl_clients = responsereload_clients.data.tbl_clients || [];

            this.clients_list = tbl_clients
              .filter(c => c.wallboxStatus !== 'no_connection')   // bug fix: use filter, no splice in loop
              .sort((a, b) => {
                // groupId desc, then idx asc (single sort instead of two)
                if (b.groupId !== a.groupId) return b.groupId - a.groupId;
                return a.idx - b.idx;
              });

            this.clients_list.forEach(item => {
              if (item.name) item.name = this.decodeHtml(item.name);
              if (item.info) item.info = this.decodeHtml(item.info);
            });

            if (this.clients_list.length === 1) {
              this.client_info = this.clients_list[0];
            } else {
              this.client_info =
                this.clients_list.find(wb => wb.id === WbId) || this.clients_list[0];
            }

            this.solarchargemode = this.client_info.chargingMode;

            if (this.client_info.wallboxStatus === 'error') {
              this.getErrorStatus();
            }
          } else {
            console.log('Error poll reload_clients Operator Admin');
          }
        } else {
          // SINGLE WB (NO MESH)
          if (responsereload_clients.data.status === 'ok') {
            this.client_info = responsereload_clients.data.tbl_clientsettings || {};
            this.solarchargemode = this.client_info.chargingMode;

            if (this.client_info.name) {
              this.client_info.name = this.decodeHtml(this.client_info.name);
            }
            if (this.client_info.info) {
              this.client_info.info = this.decodeHtml(this.client_info.info);
            }

            if (this.client_info.wallboxStatus === 'error') {
              this.getErrorStatus();
            }
          } else {
            console.log('Error poll client_info Operator Admin ohne Mesh');
          }
        }

        // ------------------------------------------------------------------
        // 2) SCHEDULE
        // ------------------------------------------------------------------
        if (responseclient_schedule.data.status === 'ok') {
          this.client_schedule = responseclient_schedule.data.tbl_statistic || null;

          if (this.client_schedule) {
            this.charging = true;
            this.loadedenergy = (this.client_schedule.energy || 0) / 1000;
            this.chargerfid = this.client_schedule.user;

            if (this.client_schedule.user === '##FREE_CHARGING##') {
              this.freecharging = true;
              this.chargecolor = '#6b7280';
            } else {
              this.freecharging = false;

              const hasPairings =
                Array.isArray(this.client_pairings) &&
                this.client_pairings.length > 0; // bug fix: correct array check

                if (hasPairings) {
                  const idx = this.client_pairings.findIndex(
                    wb => wb.token === this.client_schedule.user
                  );

                  if (idx !== -1) {
                    this.chargerfidinfo = this.decodeHtml(
                      this.client_pairings[idx].info ?? this.client_schedule.user
                    );

                    if (Array.isArray(this.client_userlist) && this.client_userlist.length > 0) {
                      const user = this.client_userlist.find(
                        u => u.userId === this.client_pairings[idx].user
                      );
                      if (user) {
                        this.chargeusername = user.name ?? '';
                      }
                    }

                    this.chargecolor = '#6b7280';
                    if (this.client_pairings[idx].color) {
                      this.chargecolor = `#${this.client_pairings[idx].color}`;
                    }
                  } else {
                    this.chargerfidinfo = this.decodeHtml(this.client_schedule.user ?? '');
                    this.chargecolor = '#6b7280';
                  }
                } else {
                  this.chargerfidinfo = this.decodeHtml(this.client_schedule.user ?? '');
                  this.chargecolor = '#6b7280';
                }
            }

            // Timezone: assume backend gives a proper timestamp; just format
            this.chargestarttime = this.$dayjs.utc(this.client_schedule.start)?.local().format('HH:mm');
          } else {
            this.charging = false;
            this.chargerfid = '';
            this.chargerfidinfo = '';
          }
        } else {
          console.log('Error poll client_schedule Operator Admin');
        }

        // ------------------------------------------------------------------
        // 3) MID METER
        // ------------------------------------------------------------------
        if (responseclient_mid.data.status === 'ok') {
          this.client_mid = responseclient_mid.data.tbl_mid_meter || {};

          const powerL1 = this.client_mid.powerL1 || 0;
          const powerL2 = this.client_mid.powerL2 || 0;
          const powerL3 = this.client_mid.powerL3 || 0;

          this.chargepower = (powerL1 + powerL2 + powerL3) / 1000000;
          this.donutchargepower = this.chargepower * 1000;

          if (this.sections && this.sections[0]) {
            this.sections[0].value = this.donutchargepower;
          }
        } else {
          console.log('Error poll client_mid Operator Admin');
        }

        // ------------------------------------------------------------------
        // 4) STATUS (internet / ocpp / wlan / lte)
        // ------------------------------------------------------------------
        if (responseclient_status.data.status === 'ok') {
          const statusData = responseclient_status.data.tbl_status || {};
          const apiVersion = Number(this.$store.state.WbApiVersion || 0);

          if (apiVersion >= 3.2) {
            this.statinternet = statusData.internetStatus;
            this.statdlm = statusData.dlmStatus;
            this.statp14 = statusData.p14Status;
            this.statocpp = statusData.ocppStatus;
            this.statocppdlm = statusData.ocppDlmStatus;
            this.statwlan = statusData.wlanQuality;
            this.statlte = statusData.lteQuality;
          } else {
            // Older API: we might only have ocpp fields
            this.statinternet = undefined;
            this.statdlm = undefined;
            this.statp14 = undefined;
            this.statocpp = statusData.ocppStatus;
            this.statocppdlm = statusData.ocppDlmStatus;
            this.statwlan = undefined;
            this.statlte = undefined;
          }
        } else {
          // Don't access tbl_status when status != 'ok' (bug fix)
          console.log('Error poll client_status Operator Admin');
          this.statinternet = undefined;
          this.statdlm = undefined;
          this.statp14 = undefined;
          this.statocpp = undefined;
          this.statocppdlm = undefined;
          this.statwlan = undefined;
          this.statlte = undefined;
        }

        // ------------------------------------------------------------------
        // 5) LOAD TIME (depends on schedule + mid)
        // ------------------------------------------------------------------
        if (
          responseclient_schedule.data.status === 'ok' &&
          responseclient_mid.data.status === 'ok' &&
          this.client_schedule &&
          this.client_mid
        ) {
          let totalMilliseconds;

          if (!this.client_mid.lastUpdate) {
            // If no lastUpdate, compare "now" with start (no manual tz hack)
            totalMilliseconds = this.$dayjs().diff(this.client_schedule.start);
          } else {
            totalMilliseconds = this.$dayjs(this.client_mid.lastUpdate).diff(
              this.client_schedule.start
            );
          }

          if (totalMilliseconds < 0) totalMilliseconds = 0;

          const totalSeconds = Math.floor(totalMilliseconds / 1000);
          const totalMinutes = Math.floor(totalSeconds / 60);
          const totalHours = Math.floor(totalMinutes / 60);

          this.loadtime = this.$t('main.loadtime', {
            hours: totalHours,
            minutes: (`0${totalMinutes % 60}`).slice(-2),
          });
        } else {
          this.loadtime = this.$t('main.loadtimeunknown');
        }

        // ------------------------------------------------------------------
        // 6) NEXT POLL
        // ------------------------------------------------------------------
        const statusesOk =
          responsereload_clients.data.status !== '' &&
          responseclient_schedule.data.status !== '' &&
          responseclient_mid.data.status !== '' &&
          responseclient_status.data.status !== '';

        if (statusesOk && this.polling) {
          setTimeout(() => {
            this.execpoll(this.polling);
          }, 1000);
        }
      } catch (errors) {
        console.error(errors);
        this.execpoll(this.polling);
      }
    },
    execpoll(polling){
      if(polling){
      this.pollData();        
      }
    },
    async updatepage() {
      this.isLoading = true;

      const { token, WbId, Mesh, WbLogHost } = this.$store.state;

      const client_swversionUrl  = `wallbox/info.php?action=get_version&user=${token}&client=${WbId}`;
      const clients_listUrl      = `wallbox/client.php?action=get_clients&user=${token}`;
      const client_statusUrl     = `wallbox/info.php?action=get_status&user=${token}&client=${WbId}`;
      const client_settingUrl    = `wallbox/info.php?action=get_settings&user=${token}&client=${WbId}`;
      const client_scheduleUrl   = `wallbox/info.php?action=get_schedule&user=${token}&client=${WbId}`;
      const client_midUrl        = `wallbox/info.php?action=get_mid_status&user=${token}&client=${WbId}`;
      const client_pairingsUrl   = `wallbox/pairing.php?action=list_pairings&user=${token}&client=${WbId}&typ=charging_token`;
      const client_selfpvUrl     = `wallbox/info.php?action=get_selfconsumption&user=${token}&client=${WbId}`;

      try {
        const [
          responseclient_swversion,
          responseclients_list,
          responseclient_status,
          responseclient_setting,
          responseclient_schedule,
          responseclient_mid,
          responseclient_pairings,
          responseclient_selfpv,
        ] = await Promise.all([
          this.axios.get(client_swversionUrl),
          this.axios.get(clients_listUrl),
          this.axios.get(client_statusUrl),
          this.axios.get(client_settingUrl),
          this.axios.get(client_scheduleUrl),
          this.axios.get(client_midUrl),
          this.axios.get(client_pairingsUrl),
          this.axios.get(client_selfpvUrl),
        ]);

        // ----------------------------------------------------
        // 1) SW VERSION
        // ----------------------------------------------------
        if (responseclient_swversion.data.status === 'token') {
          this.$router.push({ path: '/' });
          return;
        } else if (responseclient_swversion.data.status === 'ok') {
          const version = responseclient_swversion.data.tbl_version || {};
          const apiVersion = Number(version.apiVersion || 0);

          this.$store.commit('setWbApiVersion', apiVersion);
          this.$store.commit('setWbRemoteSettings', apiVersion >= 2);

          const { linuxVersion, otiVersion, otiInfo } = version;

          if (linuxVersion && otiVersion && linuxVersion !== otiVersion) {
            this.$store.commit('setNewSW', true);
            this.$store.commit('setWbOtiVersion', otiVersion);
            this.$store.commit('setWbOtiInfo', otiInfo);
          } else {
            this.$store.commit('setNewSW', false);
            this.$store.commit('setWbOtiInfo', otiInfo);
          }
        } else if (responseclient_swversion.data.status === 'parameter') {
          this.$store.commit('setWbRemoteSettings', false);
        } else {
          console.log('Error get client_swversion Operator Admin');
        }

        // ----------------------------------------------------
        // 2) CLIENTS LIST
        // ----------------------------------------------------
        if (responseclients_list.data.status === 'ok') {
          const tbl_clients = responseclients_list.data.tbl_clients || [];

          this.clients_list = tbl_clients
            .filter(c => c.wallboxStatus !== 'no_connection') // bugfix: no splice in loop
            .sort((a, b) => {
              // combine both sorts: groupId desc, then idx asc
              if (b.groupId !== a.groupId) return b.groupId - a.groupId;
              return a.idx - b.idx;
            });

          this.clients_list.forEach(item => {
            if (item.name) item.name = this.decodeHtml(item.name);
            if (item.info) item.info = this.decodeHtml(item.info);
          });

          if (this.clients_list.length === 1) {
            this.client_info = this.clients_list[0];
          } else {
            this.client_info =
              this.clients_list.find(wb => wb.id === WbId) || this.clients_list[0];
          }

          this.solarchargemode = this.client_info.chargingMode;

          this.meshsize = Mesh ? this.clients_list.length : 0;

          // Navliste anpassen
          this.logbox = this.client_info.hostname === WbLogHost;
          this.buildnavlist();
        } else if (responseclients_list.data.status === 'token') {
          this.$router.push({ path: '/' });
          return;
        } else {
          console.log('Error get clients_list Operator Admin');
        }

        // ----------------------------------------------------
        // 3) STATUS
        // ----------------------------------------------------
        if (responseclient_status.data.status === 'ok') {
          this.client_status = responseclient_status.data.tbl_status || {};
        } else if (responseclient_status.data.status === 'token') {
          this.$router.push({ path: '/' });
          return;
        } else {
          console.log('Error get client_status Operator Admin');
        }

        // ----------------------------------------------------
        // 4) SETTINGS
        // ----------------------------------------------------
        if (responseclient_setting.data.status === 'ok') {
          this.client_setting = responseclient_setting.data.tbl_settings || {};

          const maxCurrentOperator = this.client_setting.maxCurrentOperator || 0;
          const noOfPhasesInstall  = this.client_setting.noOfPhasesInstall || 0;
          const maxCurrentInstall  = this.client_setting.maxCurrentInstall || 0;

          this.donutmaxchargepower = maxCurrentOperator * noOfPhasesInstall * 230;
          this.maxchargepower = this.donutmaxchargepower / 1000;

          this.optpower = maxCurrentOperator;
          this.optpowermax = maxCurrentInstall;
          this.optphase = noOfPhasesInstall;
        } else if (responseclient_setting.data.status === 'token') {
          this.$router.push({ path: '/' });
          return;
        } else {
          console.log('Error get client_setting Operator Admin');
        }

        // ----------------------------------------------------
        // 5) SCHEDULE
        // ----------------------------------------------------
        if (responseclient_schedule.data.status === 'ok') {
          this.client_schedule = responseclient_schedule.data.tbl_statistic || null;

          if (this.client_schedule) {
            this.charging = true;
            this.loadedenergy = (this.client_schedule.energy || 0) / 1000;
            this.chargerfid = this.client_schedule.user;

            if (this.client_schedule.user === '##FREE_CHARGING##') {
              this.freecharging = true;
              this.chargecolor = '#6b7280';
            } else {
              this.freecharging = false;

              const hasPairings =
                Array.isArray(this.client_pairings) &&
                this.client_pairings.length > 0; // bugfix: array check

                if (hasPairings) {
                  const idx = this.client_pairings.findIndex(
                    wb => wb.token === this.client_schedule.user
                  );

                  if (idx !== -1) {
                    this.chargerfidinfo = this.decodeHtml(
                      this.client_pairings[idx].info ?? this.client_schedule.user
                    );

                    if (Array.isArray(this.client_userlist) && this.client_userlist.length > 0) {
                      const user = this.client_userlist.find(
                        u => u.userId === this.client_pairings[idx].user
                      );
                      if (user) {
                        this.chargeusername = user.name ?? '';
                      }
                    }

                    this.chargecolor = '#6b7280';
                    if (this.client_pairings[idx].color) {
                      this.chargecolor = `#${this.client_pairings[idx].color}`;
                    }
                  } else {
                    this.chargerfidinfo = this.decodeHtml(this.client_schedule.user ?? '');
                    this.chargecolor = '#6b7280';
                  }
                } else {
                  this.chargerfidinfo = this.decodeHtml(this.client_schedule.user ?? '');
                  this.chargecolor = '#6b7280';
                }
            }

            // Time: assume backend gives a proper timestamp; just format it
            this.chargestarttime = this.$dayjs.utc(this.client_schedule.start)?.local().format('HH:mm');
          } else {
            this.charging = false;
            this.chargerfid = '';
            this.chargerfidinfo = '';
          }
        } else if (responseclient_schedule.data.status === 'token') {
          this.$router.push({ path: '/' });
          return;
        } else {
          console.log('Error get client_schedule Operator Admin');
        }

        // ----------------------------------------------------
        // 6) MID
        // ----------------------------------------------------
        if (responseclient_mid.data.status === 'ok') {
          this.client_mid = responseclient_mid.data.tbl_mid_meter || {};
          this.energytotal = (this.client_mid.energyTotal || 0) / 1000;
        } else if (responseclient_mid.data.status === 'token') {
          this.$router.push({ path: '/' });
          return;
        } else {
          console.log('Error get client_mid Operator Admin');
        }

        // ----------------------------------------------------
        // 7) PAIRINGS
        // ----------------------------------------------------
        if (responseclient_pairings.data.status === 'ok') {
          this.client_pairings =
            responseclient_pairings.data.tbl_remote_pairing || [];
          // console.log(this.client_pairings);
        } else if (responseclient_pairings.data.status === 'token') {
          this.$router.push({ path: '/' });
          return;
        } else {
          console.log('Error get client_pairings Operator Admin');
        }

        // ----------------------------------------------------
        // 8) SELF-PV
        // ----------------------------------------------------
        if (responseclient_selfpv.data.status === 'ok') {
          const self = responseclient_selfpv.data.tbl_selfconsumption || {};
          this.solarcharge = self.enabled === 1;
        } else if (responseclient_selfpv.data.status === 'token') {
          this.$router.push({ path: '/' });
          return;
        } else {
          console.log('Error get self consumption Operator Admin');
        }

        // ----------------------------------------------------
        // 9) DONE → start polling
        // ----------------------------------------------------
        this.polling = true;
        this.pollData();
      } catch (error) {
        console.error('Error in updatepage:', error);
        // optional: this.$router.push({ path: '/' });
      } finally {
        this.isLoading = false;
      }
    },
   buildnavlist(){
      this.navlist = [];

      if(this.$store.state.Mesh)
        this.navlist.push({id:1,title: this.t('menu.mesh'),target:'/System',viewboxIcon:'0 96 960 960', icon:'M226 896q-28 0-47-19t-19-47q0-28 19-47t47-19q28 0 47 19t19 47q0 28-19 47t-47 19Zm254 0q-28 0-47-19t-19-47q0-28 19-47t47-19q28 0 47 19t19 47q0 28-19 47t-47 19Zm254 0q-28 0-47-19t-19-47q0-28 19-47t47-19q28 0 47 19t19 47q0 28-19 47t-47 19ZM226 642q-28 0-47-19t-19-47q0-28 19-47t47-19q28 0 47 19t19 47q0 28-19 47t-47 19Zm254 0q-28 0-47-19t-19-47q0-28 19-47t47-19q28 0 47 19t19 47q0 28-19 47t-47 19Zm254 0q-28 0-47-19t-19-47q0-28 19-47t47-19q28 0 47 19t19 47q0 28-19 47t-47 19ZM226 388q-28 0-47-19t-19-47q0-28 19-47t47-19q28 0 47 19t19 47q0 28-19 47t-47 19Zm254 0q-28 0-47-19t-19-47q0-28 19-47t47-19q28 0 47 19t19 47q0 28-19 47t-47 19Zm254 0q-28 0-47-19t-19-47q0-28 19-47t47-19q28 0 47 19t19 47q0 28-19 47t-47 19Z'}); 
      if(this.$store.state.Role=='operator')
        this.navlist.push({id:2,title: this.t('menu.statistic'),target:'/Statistic',viewboxIcon:'0 96 960 960',icon:'M284 779h60V504h-60v275Zm166 0h60V373h-60v406Zm166 0h60V631h-60v148ZM180 936q-24 0-42-18t-18-42V276q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Z'});
      this.navlist.push({id:3,title: this.t('menu.pairings'),target:'/Cards',viewboxIcon:'0 96 960 960',icon:'M222 801q63-40 124.5-60.5T480 720q72 0 134 20.5T739 801q44-54 62.5-109T820 576q0-145-97.5-242.5T480 236q-145 0-242.5 97.5T140 576q0 61 19 116t63 109Zm257.814-195Q422 606 382.5 566.314q-39.5-39.686-39.5-97.5t39.686-97.314q39.686-39.5 97.5-39.5t97.314 39.686q39.5 39.686 39.5 97.5T577.314 566.5q-39.686 39.5-97.5 39.5Zm-.219 370q-83.146 0-156.275-31.5t-127.225-86Q142 804 111 731.159 80 658.319 80 575.5q0-82.819 31.5-155.659Q143 347 197.5 293t127.341-85.5Q397.681 176 480.5 176q82.819 0 155.659 31.5Q709 239 763 293t85.5 127Q880 493 880 575.734q0 82.734-31.5 155.5T763 858.5q-54 54.5-127.129 86T479.595 976Z'});
      if(this.midavailable)
      this.navlist.push({id:4,title: this.t('menu.energymeter'),target:'/Status',viewboxIcon:'0 96 960 960',icon:'M481 976q-82 0-155-31.5T198.5 859q-54.5-54-86-127T81 577q0-158 106.5-272T452 179v102q-115 11-192 95.5T183 577q0 124 87 210.5T481 874q72 0 136-32.5T726 750l88 51q-58 83-145.5 129T481 976Zm362-229-88-49q12-31 18-61.5t6-60.5q0-116-76.5-201T512 280V178q157 11 263 124.5T881 572q0 45-9.5 88.5T843 747Z'});
      if(this.$store.state.Mesh)
        this.navlist.push({id:5,title: this.t('menu.editmesh'),target:'/SystemSort',viewboxIcon:'0 96 960 960',icon:'M226 896q-28 0-47-19t-19-47q0-28 19-47t47-19q28 0 47 19t19 47q0 28-19 47t-47 19Zm0-254q-28 0-47-19t-19-47q0-28 19-47t47-19q28 0 47 19t19 47q0 28-19 47t-47 19Zm0-254q-28 0-47-19t-19-47q0-28 19-47t47-19q28 0 47 19t19 47q0 28-19 47t-47 19Zm254 254q-28 0-47-19t-19-47q0-28 19-47t47-19q28 0 47 19t19 47l-66 66Zm0-254q-28 0-47-19t-19-47q0-28 19-47t47-19q28 0 47 19t19 47q0 28-19 47t-47 19Zm-40 508v-65l243-243 65 65-243 243h-65Zm294-508q-28 0-47-19t-19-47q0-28 19-47t47-19q28 0 47 19t19 47q0 28-19 47t-47 19Zm40 239-65-65 25-25q8-8 20-8.5t20 7.5l26 26q8 8 7.5 20t-8.5 20l-25 25Z'}); 

      this.navlist.push({id:6,title: this.t('menu.protocol'),target:'/EventLog',viewboxIcon:'0 -960 960 960',icon:'M640-120q-33 0-56.5-23.5T560-200v-160q0-33 23.5-56.5T640-440h160q33 0 56.5 23.5T880-360v160q0 33-23.5 56.5T800-120H640Zm0-80h160v-160H640v160ZM80-240v-80h360v80H80Zm560-280q-33 0-56.5-23.5T560-600v-160q0-33 23.5-56.5T640-840h160q33 0 56.5 23.5T880-760v160q0 33-23.5 56.5T800-520H640Zm0-80h160v-160H640v160ZM80-640v-80h360v80H80Zm640 360Zm0-400Z'});

      if(!this.$store.state.Mesh)
        this.navlist.push({id:7,title: this.t('menu.settings'),target:'/Settings',viewboxIcon:'0 96 960 960',icon:'M427 936V711h60v83h353v60H487v82h-60Zm-307-82v-60h247v60H120Zm187-166v-82H120v-60h187v-84h60v226h-60Zm120-82v-60h413v60H427Zm166-165V216h60v82h187v60H653v83h-60Zm-473-83v-60h413v60H120Z'});
      else if(this.$store.state.WbRemoteSettings||this.logbox)
        this.navlist.push({id:7,title: this.t('menu.settings'),target:'/Settings',viewboxIcon:'0 96 960 960',icon:'M427 936V711h60v83h353v60H487v82h-60Zm-307-82v-60h247v60H120Zm187-166v-82H120v-60h187v-84h60v226h-60Zm120-82v-60h413v60H427Zm166-165V216h60v82h187v60H653v83h-60Zm-473-83v-60h413v60H120Z'});

   },
   getErrorStatus(){
    this.axios
          .get('wallbox/info.php?action=get_status&user='+this.$store.state.token+'&client='+this.$store.state.WbId)
          .then((response) => {         
                      if(response.data.status=='ok'){
                        if(this.errorcodetabelle.findIndex(x => x.error === response.data.tbl_status.errorCode)==-1)
                          this.errorcodetxt = response.data.tbl_status.errorCode;
                        else
                          this.errorcodetxt = this.errorcodetabelle[this.errorcodetabelle.findIndex(x => x.error === response.data.tbl_status.errorCode)].errortext;
                        
                      }else{
                        console.log('Error get Polldata');                   
                      }
                    })
          .catch((errors) => {
              console.log(errors); // Errors
                    });
   },
    async initWallboxData() {
      this.isLoading = true;

      const { token, WbId, WbLogSerial, WbLogHost, FirstLoad } = this.$store.state;

      const client_swversionUrl  = `wallbox/info.php?action=get_version&user=${token}&client=${WbId}`;
      const client_infoUrl       = `wallbox/client.php?action=client_info&user=${token}`;
      const clients_listUrl      = `wallbox/client.php?action=get_clients&user=${token}`;
      const client_statusUrl     = `wallbox/info.php?action=get_status&user=${token}&client=${WbId}`;
      const client_settingUrl    = `wallbox/info.php?action=get_settings&user=${token}&client=${WbId}`;
      const client_scheduleUrl   = `wallbox/info.php?action=get_schedule&user=${token}&client=${WbId}`;
      const client_midUrl        = `wallbox/info.php?action=get_mid_status&user=${token}&client=${WbId}`;
      const client_pairingsUrl   = `wallbox/pairing.php?action=list_pairings&user=${token}&client=${WbId}&typ=charging_token`;
      const client_selfpvUrl     = `wallbox/info.php?action=get_selfconsumption&user=${token}&client=${WbId}`;
      const client_userlistUrl   = `wallbox/user.php?action=user_reload&user=${token}`;

      try {
        const [
          responseclient_swversion,
          responseclient_info,
          responseclients_list,
          responseclient_status,
          responseclient_setting,
          responseclient_schedule,
          responseclient_mid,
          responseclient_pairings,
          responseclient_selfpv,
          responseclient_userlist,
        ] = await Promise.all([
          this.axios.get(client_swversionUrl),
          this.axios.get(client_infoUrl),
          this.axios.get(clients_listUrl),
          this.axios.get(client_statusUrl),
          this.axios.get(client_settingUrl),
          this.axios.get(client_scheduleUrl),
          this.axios.get(client_midUrl),
          this.axios.get(client_pairingsUrl),
          this.axios.get(client_selfpvUrl),
          this.axios.get(client_userlistUrl),
        ]);

        // ------------------------------------------------------------------
        // 1) SW VERSION
        // ------------------------------------------------------------------
        if (responseclient_swversion.data.status === 'token') {
          this.$router.push({ path: '/' });
          return;
        } else if (responseclient_swversion.data.status === 'ok') {
          const { apiVersion, linuxVersion, otiVersion, otiInfo } =
            responseclient_swversion.data.tbl_version || {};

          this.$store.commit('setWbApiVersion', Number(apiVersion || 0));
          this.$store.commit('setWbRemoteSettings', Number(apiVersion) >= 2);

          if (
            linuxVersion &&
            otiVersion &&
            linuxVersion !== otiVersion
          ) {
            this.$store.commit('setNewSW', true);
            this.$store.commit('setWbOtiVersion', otiVersion);
            this.$store.commit('setWbOtiInfo', otiInfo);
          } else {
            this.$store.commit('setNewSW', false);
            this.$store.commit('setWbOtiInfo', otiInfo);
          }
        } else if (responseclient_swversion.data.status === 'parameter') {
          this.$store.commit('setWbRemoteSettings', false);
        } else {
          console.log('Error get client_swversion Operator Admin');
        }

        // ------------------------------------------------------------------
        // 2) CLIENT INFO
        // ------------------------------------------------------------------
        if (responseclient_info.data.status === 'token') {
          this.$router.push({ path: '/' });
          return;
        } else if (responseclient_info.data.status === 'ok') {
          this.client_info = responseclient_info.data.tbl_clientsettings || {};

          this.solarchargemode = this.client_info.chargingMode || 'Fast';

          if (this.client_info.name) {
            this.client_info.name = this.decodeHtml(this.client_info.name);
          }
          if (this.client_info.info) {
            this.client_info.info = this.decodeHtml(this.client_info.info);
          }
        } else {
          console.log('Error get client_info Operator Admin ohne Mesh');
        }

        // ------------------------------------------------------------------
        // 3) CLIENTS LIST / MESH
        // ------------------------------------------------------------------
        if (responseclients_list.data.status === 'token') {
          this.$router.push({ path: '/' });
          return;
        } else if (responseclients_list.data.status === 'ok') {
          const tbl_clients = responseclients_list.data.tbl_clients || [];

          if (tbl_clients.length > 1) {
            // First time: set mesh status and selected wallbox from serial
            if (FirstLoad) {
              const foundIdx = tbl_clients.findIndex(
                wb => wb.serial === WbLogSerial
              );
              if (foundIdx !== -1) {
                const id = tbl_clients[foundIdx].id;
                this.$store.commit('setMesh', true);
                this.$store.commit('setWbId', id);
                this.$store.commit('setWbLogId', id);
              }
              this.$store.commit('setFirstLoad', false);
            }

            // Filter out no_connection without using splice in loop (bug fix)
            this.clients_list = tbl_clients
              .filter(c => c.wallboxStatus !== 'no_connection')
              .sort((a, b) => {
                // sort by groupId desc, then idx asc
                if (b.groupId !== a.groupId) return b.groupId - a.groupId;
                return a.idx - b.idx;
              });

            // Decode HTML fields safely
            this.clients_list.forEach(item => {
              if (item.name) item.name = this.decodeHtml(item.name);
              if (item.info) item.info = this.decodeHtml(item.info);
            });

            // Still no WbId → pick by serial
            if (this.$store.state.WbId === -1) {
              const foundIdx = tbl_clients.findIndex(
                wb => wb.serial === WbLogSerial
              );
              if (foundIdx !== -1) {
                const id = tbl_clients[foundIdx].id;
                this.$store.commit('setMesh', true);
                this.$store.commit('setWbId', id);
                this.$store.commit('setWbLogId', id);
              }
              this.$store.commit('setFirstLoad', false);
            }

            // Set current client_info from list
            if (this.clients_list.length === 1) {
              this.client_info = this.clients_list[0];
            } else {
              this.client_info =
                this.clients_list.find(
                  wb => wb.id === this.$store.state.WbId
                ) || this.clients_list[0];
            }

            this.solarchargemode = this.client_info.chargingMode;
            this.meshsize = this.clients_list.length;

            this.logbox = this.client_info.hostname === WbLogHost;
            this.buildnavlist();
          } else {
            // No mesh / only one WB
            if (FirstLoad) {
              this.$store.commit('setMesh', false);
              this.$store.commit('setWbId', -1);
              this.$store.commit('setWbLogId', -1);
              this.$store.commit('setFirstLoad', false);
            }
            this.buildnavlist();
          }
        } else {
          console.log('Error get clients_list Operator Admin');
        }

        // ------------------------------------------------------------------
        // 4) CLIENT STATUS
        // ------------------------------------------------------------------
        if (responseclient_status.data.status === 'token') {
          this.$router.push({ path: '/' });
          return;
        } else if (responseclient_status.data.status === 'ok') {
          this.client_status = responseclient_status.data.tbl_status || {};
        } else {
          console.log('Error get client_status Operator Admin');
        }

        // ------------------------------------------------------------------
        // 5) CLIENT SETTINGS
        // ------------------------------------------------------------------
        if (responseclient_setting.data.status === 'token') {
          this.$router.push({ path: '/' });
          return;
        } else if (responseclient_setting.data.status === 'ok') {
          this.client_setting = responseclient_setting.data.tbl_settings || {};

          this.midavailable = (this.client_setting.mid || 0) > 0;

          this.buildnavlist();

          const maxCurrentOperator = this.client_setting.maxCurrentOperator || 0;
          const noOfPhasesInstall  = this.client_setting.noOfPhasesInstall || 0;
          const maxCurrentInstall  = this.client_setting.maxCurrentInstall || 0;

          this.donutmaxchargepower =
            maxCurrentOperator * noOfPhasesInstall * 230;

          this.maxchargepower = this.donutmaxchargepower / 1000;
          this.optpower = maxCurrentOperator;
          this.optpowermax = maxCurrentInstall;
          this.optphase = noOfPhasesInstall;

          this.resetoptcharge();
        } else {
          console.log('Error get client_setting Operator Admin');
        }

        // ------------------------------------------------------------------
        // 6) SCHEDULE + PAIRINGS
        // ------------------------------------------------------------------
        if (
          responseclient_schedule.data.status === 'token' ||
          responseclient_pairings.data.status === 'token'
        ) {
          this.$router.push({ path: '/' });
          return;
        } else if (
          responseclient_schedule.data.status === 'ok' &&
          responseclient_pairings.data.status === 'ok'
        ) {
          this.client_schedule =
            responseclient_schedule.data.tbl_statistic || null;
          this.client_pairings =
            responseclient_pairings.data.tbl_remote_pairing || [];

          if (this.client_schedule) {
            this.charging = true;
            this.loadedenergy = (this.client_schedule.energy || 0) / 1000;
            this.chargerfid = this.client_schedule.user;

            if (this.client_schedule.user === '##FREE_CHARGING##') {
              this.freecharging = true;
              this.chargecolor = '#6b7280';
            } else {
              this.freecharging = false;

              const hasPairings =
                Array.isArray(this.client_pairings) &&
                this.client_pairings.length > 0; // bug fix: proper array check

                if (hasPairings) {
                  const idx = this.client_pairings.findIndex(
                    wb => wb.token === this.client_schedule.user
                  );

                  if (idx !== -1) {
                    this.chargerfidinfo = this.decodeHtml(
                      this.client_pairings[idx].info ?? this.client_schedule.user
                    );

                    if (Array.isArray(this.client_userlist) && this.client_userlist.length > 0) {
                      const user = this.client_userlist.find(
                        u => u.userId === this.client_pairings[idx].user
                      );
                      if (user) {
                        this.chargeusername = user.name ?? '';
                      }
                    }

                    this.chargecolor = '#6b7280';
                    if (this.client_pairings[idx].color) {
                      this.chargecolor = `#${this.client_pairings[idx].color}`;
                    }
                  } else {
                    this.chargerfidinfo = this.decodeHtml(this.client_schedule.user ?? '');
                    this.chargecolor = '#6b7280';
                  }
                } else {
                  this.chargerfidinfo = this.decodeHtml(this.client_schedule.user ?? '');
                  this.chargecolor = '#6b7280';
                }
            }

            // Assume backend date is already correct; just format it
            this.chargestarttime = this.$dayjs.utc(
              this.client_schedule.start
            ).local().format('HH:mm');
          } else {
            this.charging = false;
            this.chargerfid = '';
            this.chargerfidinfo = '';
          }
        } else {
          console.log('Error get client_schedule Operator Admin');
        }

        // ------------------------------------------------------------------
        // 7) MID METER
        // ------------------------------------------------------------------
        if (responseclient_mid.data.status === 'token') {
          this.$router.push({ path: '/' });
          return;
        } else if (responseclient_mid.data.status === 'ok') {
          this.client_mid = responseclient_mid.data.tbl_mid_meter || {};

          const powerL1 = this.client_mid.powerL1 || 0;
          const powerL2 = this.client_mid.powerL2 || 0;
          const powerL3 = this.client_mid.powerL3 || 0;

          this.energytotal = (this.client_mid.energyTotal || 0) / 1000;
          this.chargepower = (powerL1 + powerL2 + powerL3) / 1000000;

          this.donutchargepower = this.chargepower * 1000;
          if (this.sections && this.sections[0]) {
            this.sections[0].value = this.donutchargepower;
          }
        } else {
          console.log('Error get client_mid Operator Admin');
        }

        // ------------------------------------------------------------------
        // 8) LOAD TIME (needs schedule + mid)
        // ------------------------------------------------------------------
        if (
          responseclient_schedule.data.status === 'ok' &&
          responseclient_mid.data.status === 'ok' &&
          this.client_schedule &&
          this.client_mid
        ) {
          let totalMilliseconds = this.$dayjs(
            this.client_mid.lastUpdate
          ).diff(this.client_schedule.start);

          if (totalMilliseconds < 0) totalMilliseconds = 0;

          const totalSeconds = Math.floor(totalMilliseconds / 1000);
          const totalMinutes = Math.floor(totalSeconds / 60);
          const totalHours = Math.floor(totalMinutes / 60);

          this.loadtime = this.$t('main.loadtime', {
            hours: totalHours,
            minutes: (`0${totalMinutes % 60}`).slice(-2),
          });
        } else {
          this.loadtime = this.$t('main.loadtimeunknown');
        }

        // ------------------------------------------------------------------
        // 9) SELF-PV / SOLAR MODE
        // ------------------------------------------------------------------
        if (responseclient_selfpv.data.status === 'token') {
          this.$router.push({ path: '/' });
          return;
        } else if (responseclient_selfpv.data.status === 'ok') {
          const self = responseclient_selfpv.data.tbl_selfconsumption || {};
          this.solarcharge = self.enabled === 1;
        } else {
          console.log('Error get self consumption Operator Admin');
        }

        // ------------------------------------------------------------------
        // 10) USERLIST
        // ------------------------------------------------------------------
        if (responseclient_userlist.data.status === 'token') {
          this.$router.push({ path: '/' });
          return;
        } else if (responseclient_userlist.data.status === 'ok') {
          this.client_userlist = (responseclient_userlist.data.tbl_user || []).map(user => ({
            ...user,
            alias: this.decodeHtml(user.alias ?? ''),
            name: this.decodeHtml(user.name ?? '')
          }));
        } else {
          console.log('Error get client_status Operator Admin');
        }

        // ------------------------------------------------------------------
        // DONE → Start polling
        // ------------------------------------------------------------------
        this.pollData();
      } catch (error) {
        console.error('Error loading wallbox data:', error);
        // optionally: this.$router.push({ path: '/' });
      } finally {
        this.isLoading = false;
      }
    },
  },
  beforeUnmount() {
    this.polling=false;
  },
  created() {
    this.initWallboxData();
  },
}
</script>
<style>
</style>


